import { PlanWithFeatures } from '../types/Billing';
import { formatNumber } from '../utils/format';

export const fr = {
  landing: {
    headline: 'Tout ce dont votre entreprise a besoin sur WhatsApp',
    subheadline:
      'Marketing, notifications, chatbots, support client et livraisons — un seul tableau de bord.',
    signUp: 'Commencer gratuitement',
    logIn: 'Se connecter',
    haveWhatsAppBusiness: 'Vous avez déjà un compte WhatsApp Business ?',
    onboardViaFacebook: 'Connecter via Facebook',
    viewPricing: 'Voir les tarifs',
    watchDemos: 'Voir les démos',
    trustedBy: 'Ils nous font confiance',
    joinTheseCompanies:
      'Rejoignez ces entreprises innovantes qui utilisent déjà notre plateforme',
    seeItInAction: 'Voyez par vous-même',
    watchMoreDemos: 'Voir plus de démos',
    products: {
      sectionTitle: 'Une plateforme, quatre applications puissantes',
      sectionSubtitle:
        "Chaque produit résout un vrai problème. N'activez que ce dont vous avez besoin.",
      clientell: {
        tagline: 'Envois groupés WhatsApp',
        description:
          'Envoyez des messages personnalisés à des milliers de clients en un clic. Créez des modèles, organisez vos contacts en groupes, planifiez vos campagnes et suivez les performances en temps réel.',
        features: [
          'Modèles de messages réutilisables avec variables dynamiques',
          'Groupes de contacts pour des campagnes ciblées',
          'Planification des envois au moment idéal',
          'Taux de livraison, accusés de lecture et analytiques',
        ],
      },
      imminote: {
        tagline: 'Notifications automatisées via API',
        description:
          'Déclenchez des notifications WhatsApp depuis vos systèmes existants. Confirmations de commande, rappels de rendez-vous, mises à jour de statut — tout est automatisé via une API simple.',
        features: [
          'API REST et SDKs multi-langages',
          'Déclencheurs événementiels et webhooks',
          'Notifications basées sur des modèles',
          'Suivi complet des livraisons et journaux',
        ],
      },
      botmaker: {
        tagline: 'Créateur de chatbot sans code',
        description:
          'Construisez des bots WhatsApp conversationnels avec un éditeur visuel par glisser-déposer. Aucun code requis. Ajoutez des réponses IA et connectez votre logique métier.',
        features: [
          'Éditeur de flux visuel par glisser-déposer',
          "Réponses alimentées par l'IA (intégration LLM)",
          'Logique conditionnelle et branchements',
          'Connexion à des APIs et bases de données externes',
        ],
      },
      whatchat: {
        tagline: 'Boîte de réception partagée',
        description:
          'Gérez toutes vos conversations WhatsApp dans une boîte de réception partagée. Assignez des agents, suivez les temps de réponse et ne manquez jamais un message client.',
        features: [
          "Boîte de réception partagée pour toute l'équipe",
          'Attribution et routage des agents',
          'Mises à jour de conversations en temps réel',
          'Historique complet des messages et recherche',
        ],
      },
      rakine: {
        tagline: 'Gestion des livraisons',
        description:
          'Suivez vos livreurs, gérez les livraisons et dispatchez les commandes en temps réel. Conçu pour les équipes logistiques qui ont besoin de visibilité et de contrôle.',
        features: [
          'Suivi de la position des livreurs en temps réel',
          'Dispatch de livraison en un clic',
          'Statut et historique des livraisons',
          'Analytiques de performance des livreurs',
        ],
      },
    },
    howItWorks: {
      title: 'Opérationnel en quelques minutes',
      step1Title: 'Connectez votre numéro',
      step1Desc:
        "Liez votre numéro WhatsApp Business via l'inscription Meta — en moins de 5 minutes.",
      step2Title: 'Choisissez vos outils',
      step2Desc:
        'Activez Clientell, Imminote, Botmaker, WhatChat ou Rakine — ne payez que ce que vous utilisez.',
      step3Title: 'Lancez-vous',
      step3Desc:
        'Envoyez des messages, automatisez les notifications ou gérez vos livraisons immédiatement.',
    },
  },
  header: {
    dabsi: 'DABSI',
    clientell: 'Clientell',
    clientellDescription: 'Joignez vos clients',
    imminote: 'Imminote',
    imminoteDescription: 'Notifications instantanées',
    botmaker: 'Botmaker',
    botmakerDescription: 'Concevez votre chatbot',
    rakine: 'Rakine',
    rakineDescription: 'Gérez vos livraisons',
    whatchat: 'WhatChat',
    whatchatDescription: 'Conversations en direct',
    home: 'Accueil',
    profile: 'Profil',
    loading: 'Chargement en cours...',
    myProfile: 'Mon Profil',
    manageUsers: 'Gérer les Utilisateurs',
    managePlan: 'Gérer le forfait',
    apiDocs: 'Documentation API',
    accountId: 'ID du compte :',
    tutorials: 'Tutoriels',
  },
  footer: {
    faq: 'FAQ',
    demos: 'Démos',
    privacy: 'Politique de Confidentialité',
    terms: "Conditions d'Utilisation",
    copyright: 'DABSI',
  },
  nav: {
    clients: 'Clients',
    groups: 'Groupes',
    templates: 'Modèles',
    users: 'Utilisateurs',
    profile: 'Profil',
    api: 'API',
    sdk: 'SDK',
    settings: 'Paramètres',
    inbox: 'Boîte de réception',
  },
  profile: {
    subscriptionDetails: "Détails de l'abonnement",
    cancel: 'Annuler',
    cancelSubscription: "Annuler l'abonnement",
    sureToCancel:
      "Êtes-vous sûr de vouloir annuler votre abonnement ? Vous perdrez l'accès à :",
    sureToUndoCancel: 'Êtes-vous sûr de vouloir restaurer votre abonnement ?',
    sureToDowngrade:
      "Êtes-vous sûr de vouloir rétrograder votre abonnement ? Vous perdrez l'accès à certaines fonctionnalités.",
    allPremiumFeatures: 'Toutes les fonctionnalités premium',
    storedClientData:
      'Les données clients stockées au-delà de la limite gratuite',
    advancedReporting: 'Les fonctionnalités de reporting avancées',
    seePlans: 'Voir les forfaits',
    thisIsYourPlan: 'Ceci est votre forfait actuel',
    thisIsYourScheduledPlan: 'Ceci est votre prochain forfait',
    upgradeNow: 'Passer à ce forfait maintenant',
    scheduleUpgrade:
      'Passer à ce forfait à la prochaine période de facturation',
    paymentInProgress: 'Paiement en cours...',
    keepSubscription: "Garder l'abonnement",
    confirmCancellation: "Confirmer l'annulation",
    cancelling: 'Annulation en cours...',
    undoSubscriptionCancellation: "Restaurer l'abonnement",
    keepCancellation: "Garder l'annulation",
    restore: 'Restaurer',
    undoingCancel: 'Restauration en cours...',
    downgradeSubscription: "Rétrograder l'abonnement",
    keepCurrentPlan: 'Garder le forfait actuel',
    confirmDowngrade: 'Confirmer la rétrogradation',
    downgrading: 'Rétrogradation en cours...',
    currentPlan: 'Forfait actuel',
    upcomingPlan: 'Prochain forfait',
    downgrade: 'Rétrograder',
    status: 'Statut',
    actions: 'Actions',
    nextBillingDate: 'Prochaine date de facturation',
    cancellationDate: "Date d'annulation",
    monthlyPrice: 'Prix mensuel',
    recommended: 'Recommandé',
    month: 'mois',
    select: 'Sélectionner',
    simplePricing: 'Tarification simple et transparente',
    choosePlan: 'Choisissez le forfait parfait pour votre entreprise.',
    currency: 'Devise',
    customPlan:
      "Besoin d'un forfait personnalisé ? Contactez notre équipe commerciale",
    needCustomPlan: "Besoin d'un forfait personnalisé ?",
    contactSales: "Contacter l'équipe commerciale",
    tailoredSolution: 'Contactez-nous pour une solution personnalisée',
    basic: 'Basique',
    active: 'actif',
    trialing: 'en essai',
    canceled: 'annulé',
    processing: 'En cours ...',
    successPaymentTitle: 'Paiement réussi 🙂',
    successPaymentContent:
      "Votre paiement a été effectué avec succès. Merci pour votre achat ! Veuillez rafraîchir la page si votre souscription n'est pas encore mise à jour.",
    errorPaymentTitle: 'Oups ! Erreur de paiement 🙁',
    errorPaymentContent:
      'Une erreur est survenue lors du traitement de votre paiement. Veuillez réessayer.',
    close: 'Fermer',
    subscriptionTab: 'Abonnement',
    dataTab: 'Données',
    role: 'Rôle',
    seeMoreDetails: 'Voir Plus de détails',
    compareFeatures: 'Comparer les fonctionnalités',
    frequentlyAskedQuestions: 'Questions fréquentes',
  },
  plans: {
    plan: 'Forfait',
    price: 'Prix',
    phoneNumbers: 'Numéros de téléphone',
    activationFee: "Frais d'activation",
    monthlyMaintenanceFee: 'Frais mensuel de maintenance',
    utilization: 'usage',
    free: 'Gratuit',
    teamsAndClients: "Membres d'équipe & clients",
    teamMembers: "Membres d'équipe",
    clients: 'Clients',
    groups: 'Groupes',
    triggerRecipients: 'Destinataires de notifications',
    templatesAndMessages: 'Modèles & messages',
    templates: 'Modèles',
    utilityTemplateMessages: 'Messages de modèles utilitaires',
    marketingTemplateMessages: 'Messages de modèles marketing',
    nonTemplateMessages: 'Messages non-modèles',
    features: 'Fonctionnalités',
    advancedAnalytics: 'Analyses avancées',
    conversationAccess: 'Accès aux conversations clients',
    exportData: 'Exportation de données',
    customReports: 'Rapports personnalisés',
    fullApiAccess: "Accès complet à l'API",
    apiRateLimit: 'Limite de débit API',
    msgsPerSecond: 'msgs/sec',
    customIntegrations: 'Intégrations personnalisées',
    accountManager: 'Gestionnaire de compte dédié',
    multiLanguageSdkAccess: 'Accès SDK multilingue',
    llm: 'LLM',
    llmDisclaimer:
      'Pour activer votre chatbot IA, veuillez ajouter vos clés API. Nous nous intégrons parfaitement avec les principaux fournisseurs de modèles de langage, y compris OpenAI, Anthropic, et plus encore. Vos clés restent sécurisées et cryptées dans notre système.',
    dragAndDropBotMaker: 'Créateur de bot par glisser-déposer',
    messageScheduling: 'Planification de messages',
    poc: 'Preuve de concept',
    pay_as_you_go: "Paiement à l'utilisation",
    enterprise: 'Entreprise',
    professional: 'Professionnel',
    basic: 'Basique',
    priority: 'Prioritaire',
    support: 'Support',
    upTo: "Jusqu'à",
    unlimited: 'Illimité',
    pocOffer:
      "Nous proposons également un plan gratuit pour les tests. Veuillez nous contacter pour plus d'informations.",
    messageRates: {
      title: '* Tarifs des messages',
      description: 'Les tarifs varient selon le pays de destination',
      country: 'Pays',
      marketing: 'Marketing',
      utility: 'Utilitaire/Auth',
      nonTemplate: 'Non-modèle',
      perMessage: '/msg',
      countries: {
        SN: 'Sénégal',
        FR: 'France',
        US: 'États-Unis',
        AE: 'Émirats',
      },
    },
    highlightedPlanFeatures: {
      poc: (plan: PlanWithFeatures) => [
        `1 numéro de téléphone`,
        `1 membre d'équipe`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxClients)} clients`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxGroups)} groupes`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxTriggerRecipients)} destinataires de notifications`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxTemplates)} modèles`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxUtilityMessages)} messages de modèle utilitaire`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxMarketingMessages)} messages de modèle marketing`,
        `Messages non-modèles illimités`,
        `Analyses avancées`,
        `Exportation de données`,
        `Accès SDK multilingue`,
        `Support de base`,
        `Pas de frais d'activation`,
        `Pas de frais mensuel de maintenance`,
      ],
      pay_as_you_go: (plan: PlanWithFeatures) => [
        `1 numéro de téléphone`,
        `2 membres d'équipe`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxClients)} clients`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxGroups)} groupes`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxTriggerRecipients)} destinataires de notifications`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxTemplates)} modèles`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxUtilityMessages)} messages de modèle utilitaire`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxMarketingMessages)} messages de modèle marketing`,
        `Messages non-modèles illimités`,
        `Analyses avancées`,
        `Exportation de données`,
        `Accès API complet (100 msgs/sec)`,
        `Accès SDK multilingue`,
        `LLM`,
        `Créateur de bot par glisser-déposer`,
        `Support de base`,
      ],
      basic: (plan: PlanWithFeatures) => [
        `1 numéro de téléphone`,
        `1 membre d'équipe`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxClients)} clients`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxGroups)} groupes`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxTriggerRecipients)} destinataires de notifications`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxTemplates)} modèles`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxUtilityMessages)} messages de modèle utilitaire`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxMarketingMessages)} messages de modèle marketing`,
        `Messages non-modèles illimités`,
        `Analyses avancées`,
        `Exportation de données`,
        `Accès SDK multilingue`,
        `LLM`,
        `Créateur de bot par glisser-déposer`,
        `Support de base`,
        `Pas de frais mensuel de maintenance`,
      ],
      professional: (plan: PlanWithFeatures) => [
        `Jusqu'à ${formatNumber('fr', plan.features.maxPhoneNumbers)} numéros de téléphone`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxUsers)} membres d'équipe`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxClients)} clients`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxGroups)} groupes`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxTriggerRecipients)} destinataires de notifications`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxTemplates)} modèles`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxUtilityMessages)} messages de modèle utilitaire`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxMarketingMessages)} messages de modèle marketing`,
        `Messages non-modèles illimités`,
        `Analyses avancées`,
        `Exportation de données`,
        `Rapports personnalisés`,
        `Accès API complet (100 msgs/sec)`,
        `Accès SDK multilingue`,
        `LLM`,
        `Créateur de bot par glisser-déposer`,
        `Support prioritaire par email et chat`,
        `Pas de frais mensuel de maintenance`,
      ],
      enterprise: (plan: PlanWithFeatures) => [
        `Jusqu'à ${formatNumber('fr', plan.features.maxPhoneNumbers)} numéros de téléphone`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxUsers)} membres d'équipe`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxClients)} clients`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxGroups)} groupes`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxTriggerRecipients)} destinataires de notifications`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxTemplates)} modèles`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxUtilityMessages)} messages de modèle utilitaire`,
        `Jusqu'à ${formatNumber('fr', plan.features.maxMarketingMessages)} messages de modèle marketing`,
        `Messages non-modèles illimités`,
        `Planification de messages`,
        `Analyses avancées`,
        `Accès aux conversations clients`,
        `Exportation de données`,
        `Rapports personnalisés`,
        `Accès API complet (100 msgs/sec)`,
        `Intégrations personnalisées`,
        `Accès SDK multilingue`,
        `LLM`,
        `Créateur de bot par glisser-déposer`,
        `Support prioritaire par email et chat`,
        `Gestionnaire de compte dédié`,
        `Pas de frais mensuel de maintenance`,
      ],
    },
  },
  billing: {
    startFullSubscription: 'Commencer un abonnement complet',
    updateSubscription: "Mettre à jour l'abonnement",
    changePlan: 'Changer de forfait',
    reactivateSubscription: "Réactiver l'abonnement",
    trialEndsSoon: "Votre période d'essai se termine bientôt le",
    trialUntil: "Vous êtes actuellement en mode d'essai jusqu'au",
    shouldRenewSoon: 'Veuillez renouveler votre abonnement avant le',
    gracePeriodPayment:
      'Votre paiement est en retard. Veuillez renouveler votre abonnement ou il expirera le',
    subscriptionCancelling: 'Votre abonnement sera annulé le',
    subscriptionExpired: 'Votre abonnement a expiré.',
    subscriptionCanceled: 'Votre abonnement a été annulé.',
    undoCancellation: 'Ne pas annuler',
    subscriptionCancelled: "L'abonnement a été annulé.",
    subscriptionCancellationError:
      "Échec de l'annulation de l'abonnement. Veuillez réessayer plus tard.",
    subscriptionRestored: "L'abonnement a été restauré !",
    subscriptionRestoreError:
      "Échec de la restauration de l'abonnement. Veuillez réessayer plus tard.",
    currentSubscriptionKept: 'Forfait actuel conservé !',
    currentSubscriptionKeepError:
      'Échec de la conservation du forfait actuel. Veuillez réessayer plus tard.',
    subscriptionUpgradeScheduled:
      "La mise à niveau de l'abonnement a été programmée.",
    subscriptionUpgradeScheduleError:
      'Échec de la programmation de la mise à niveau. Veuillez réessayer plus tard.',
    subscriptionDowngradeScheduled:
      "La rétrogradation de l'abonnement a été programmée.",
    subscriptionDowngradeScheduleError:
      'Échec de la programmation de la rétrogradation. Veuillez réessayer plus tard.',
    choosePaymentMethod: 'Choisir le mode de paiement',
    payWithWave: 'Payer avec Wave',
    payWithBictorys: 'Payer avec Bictorys',
    paymentSuccess:
      'Paiement réussi ! Veuillez actualiser la page pour voir les changements.',
    paymentError: 'Le paiement a échoué. Veuillez réessayer.',
    checkoutInitializationError:
      'Impossible de démarrer le paiement pour le moment. Vérifiez votre connexion et réessayez.',
    subscriptionStatusFetchError:
      "Nous ne pouvons pas récupérer le statut de votre paiement d'abonnement pour le moment. Veuillez actualiser la page.",
    monthly: 'Mensuel',
    yearly: 'Annuel',
    minusTwentyPercent: '-20%',
    faqs: [
      {
        question: "Comment fonctionne l'essai gratuit ?",
        answer:
          "Vous bénéficiez d'un essai gratuit de 14 jours. Vous aurez accès à toutes les fonctionnalités du forfait basique jusqu'à l'expiration de la période d'essai. Aucune carte bancaire ni obligation requis.",
      },
      {
        question: 'Puis-je changer de forfait plus tard ?',
        answer:
          'Oui, vous pouvez passer à un forfait supérieur ou inférieur à tout moment. Votre nouveau forfait et ses fonctionnalités seront actifs à partir de votre prochaine période de facturation. Votre forfait actuel reste actif jusque-là.',
      },
      {
        question: 'Quels modes de paiement acceptez-vous ?',
        answer:
          "Nous acceptons les paiements par carte bancaire, Orange Money et Wave Money. Les clients entreprise peuvent explorer d'autres options de paiement.",
      },
      {
        question:
          'Que se passe-t-il si je dépasse les limites de mon forfait ?',
        answer:
          'Nous vous préviendrons lorsque vous approcherez de vos limites. Vous pourrez passer à un forfait supérieur ou nous contacter pour une solution personnalisée.',
      },
      {
        question: 'Offrez-vous des remboursements ?',
        answer:
          "Vous pouvez annuler votre abonnement à tout moment depuis les paramètres de votre profil. Si vous avez des préoccupations ou des problèmes, contactez notre équipe d'assistance - nous serons heureux de discuter de votre situation et d'explorer les options au cas par cas.",
      },
      {
        question:
          'Offrez-vous des réductions aux organisations à but non lucratif ?',
        answer:
          'Oui, nous proposons des tarifs spéciaux pour les organisations à but non lucratif enregistrées. Contactez notre équipe commerciale pour plus de détails.',
      },
      {
        question:
          'Que se passe-t-il avec mes clients lorsque je rétrograde mon abonnement ?',
        answer: `Lorsque vous rétrogradez votre abonnement, votre limite de clients sera réduite selon votre nouveau forfait. Par exemple, si vous passez du forfait Professionnel au forfait Basique, vous aurez toujours accès à toutes vos données, mais avec certaines limitations :

                - Clients excédentaires : Les clients au-delà de votre nouvelle limite (déterminés par les moins récemment actifs) seront placés en mode lecture seule.
                - Fonctionnalités limitées : Pour ces clients excédentaires, vous ne pourrez pas :
                • Envoyer des modèles de messages
                • Les ajouter à des groupes
                • Modifier leurs informations

                Vous pourrez toujours consulter toutes les données et l'historique des clients.`,
      },
      {
        question: "Qu'advient-il de mes groupes après la rétrogradation ?",
        answer: `Comme pour les clients, les groupes dépassant les limites de votre nouveau forfait seront mis en mode lecture seule (déterminés par les moins récemment mis à jour). Pour ces groupes excédentaires :

                - Vous ne pouvez pas y ajouter de nouveaux clients
                - Vous ne pouvez pas leur envoyer de modèles de messages
                - Vous pouvez toujours consulter toutes les données et l'historique des messages du groupe`,
      },
      {
        question: "Qu'advient-il de mes modèles après la rétrogradation ?",
        answer: `Les modèles au-delà de la limite de votre nouveau forfait seront en mode lecture seule :

                - Vous pouvez consulter ces modèles
                - Vous ne pouvez pas les modifier
                - Vous ne pouvez pas les utiliser pour envoyer des messages`,
      },
      {
        question:
          "Qu'advient-il de mes comptes utilisateurs après la rétrogradation ?",
        answer:
          'Les comptes utilisateurs au-delà de la limite de votre nouveau forfait seront mis en lecture seule. Ces utilisateurs ne pourront pas effectuer de modifications mais pourront toujours consulter les données selon leurs permissions existantes.',
      },
      {
        question:
          'Comment choisir quels clients/groupes/modèles restent actifs ?',
        answer:
          'Le système définit automatiquement vos éléments les moins récemment actifs comme étant en excès. Dans le futur, vous pourrez ajuster manuellement quels éléments restent actifs.',
      },
      {
        question: 'Puis-je récupérer mon accès complet ?',
        answer:
          "Oui ! Vous pouvez mettre à niveau votre abonnement à tout moment pour restaurer toutes les fonctionnalités de toutes vos données. Aucune information n'est supprimée pendant le processus de rétrogradation.",
      },
      {
        question: "Quelles sont les limites de débit de l'API ?",
        answer:
          "Les forfaits avec accès API complet (Paiement à l'utilisation, Professionnel et Entreprise) incluent une limite de débit de 100 messages par seconde. Cela s'applique à l'API d'envoi pour envoyer des messages WhatsApp de manière programmatique. Si vous avez besoin d'un débit plus élevé, contactez notre équipe commerciale pour une solution personnalisée.",
      },
    ],
  },
  home: {
    viewOrgs: 'Voir les Organisations',
    addOrg: 'Ajouter une Organisation',
    manageOrg: 'Gérer une Organisation',
    yourOrgs: 'Vos Organisations',
    addPhoneNumbersToOrg: "Ajouter des Numéros de Téléphone à l'Organisation",
    orgName: "Nom de l'Organisation",
    orgAddedSuccessfully: 'Organisation ajoutée avec succès !',
    errorAddingOrg: "Erreur lors de l'ajout de l'organisation...",
    noOrgs: "Vous n'avez pas encore ajouté d'organisations.",
    add: 'Ajouter',
  },
  modules: {
    clients: 'Clients',
    clientsDesc: 'Gérez vos contacts',
    groups: 'Groupes',
    groupsDesc: 'Organisez vos contacts en groupes',
    templates: 'Modèles',
    templatesDesc: 'Créez et envoyez des messages',
    users: 'Utilisateurs',
    profile: 'Profil',
    api: 'API',
    sdk: 'SDK',
    settings: 'Paramètres',
  },
  clients: {
    clients: 'Clients',
    viewClients: 'Voir les Clients',
    editMode: 'Mode édition',
    search: 'Rechercher des clients...',
    searchResultsEmpty: 'Aucun client trouvé...',
    selectCountry: 'Sélectionner un pays',
    country: 'Pays',
    phoneNumber: 'Numéro de téléphone',
    email: 'Email',
    emailOptional: 'Email (facultatif)',
    firstNameOptional: 'Prénom (facultatif)',
    middleNameOptional: 'Deuxième prénom (facultatif)',
    lastNameOptional: 'Nom (facultatif)',
    addClients: 'Ajouter des Clients',
    bulkAddClientsToOrg: "Ajout en masse de Clients à l'Organisation",
    addClientToOrg: "Ajouter un Client à l'Organisation",
    uploadCsv: 'Télécharger CSV',
    addClient: 'Ajouter Client',
    bulkAddedSuccessfully: 'Clients ajoutés en masse avec succès !',
    errorAddingInBulk: "Erreur lors de l'ajout des clients en masse...",
    addedToGroupSuccessfully: 'Client ajouté au groupe avec succès !',
    errorAddingToGroup: "Erreur lors de l'ajout du client au groupe...",
    bulkAddedToGroupSuccessfully:
      'Clients ajoutés en masse au groupe avec succès !',
    errorAddingToGroupInBulk:
      "Erreur lors de l'ajout des clients au groupe en masse...",
    noClientsYet: "Cette organisation n'a pas encore ajouté de clients.",
    uploading: 'Téléchargement en cours...',
    addClientSuccess: "Client ajouté à l'organisation avec succès !",
    addClientError: "Erreur lors de l'ajout du client à l'organisation...",
    successfullyAdded: 'Ajout réussi de',
    clientsToOrg: "clients à l'organisation.",
    csvUploadError: 'Échec du téléchargement du CSV. Veuillez réessayer.',
    successfullyUpdatedName: 'Name successfully updated for',
    errorUpdatingName: 'Error updating name for',
    successfullyUpdatedPhoneNumber:
      'Numéro de téléphone mis à jour avec succès pour',
    errorUpdatingPhoneNumber:
      'Erreur lors de la mise à jour du numéro de téléphone pour',
    successfullyDeletedClient: 'Suppression réussie du client',
    errorDeletingClient: 'Erreur lors de la suppression du client',
    phoneNumberRequired: 'Le numéro de téléphone est requis',
    invalidEmail: 'Veuillez entrer une adresse e-mail valide',
    selectCsvToAdd: 'Télécharger un CSV pour ajouter des clients',
    csvHeaders: 'Le fichier CSV doit contenir les en-têtes suivants :',
    csvRequiredColumns:
      'Seulement les colonnes country et phone_number sont obligatoires.',
    viewGroups: 'Voir les groupes',
    totalGroups: 'Total des groupes',
    errorFetchingGroups:
      'Erreur lors de la récupération des groupes du client...',
    notInAnyGroup: "Ce client n'est dans aucun groupe pour le moment",
  },
  optIn: {
    thanks: 'Merci de vous être inscrit aux messages de',
    invalidLink: 'Ce lien est invalide',
    loading: 'Chargement...',
    enterPhone:
      'Entrez votre numéro de téléphone pour vous inscrire aux messages de',
    phonePlaceholder: '7X XXX XX XX',
    sendCode: 'Envoyer le code de vérification',
    enterCode: 'Entrez le code de vérification',
    codeSent: 'Un code a été envoyé via WhatsApp au',
    verify: 'Vérifier',
    wrongCode: 'Code invalide. Veuillez réessayer.',
    sendFailed: "Échec de l'envoi du code. Veuillez réessayer.",
  },
  groups: {
    groups: 'Groupes',
    viewGroups: 'Voir les Groupes',
    editMode: 'Mode édition',
    search: 'Rechercher des groupes...',
    searchResultsEmpty: 'Aucun groupe trouvé...',
    addGroupToOrg: "Ajouter un Groupe à l'Organisation",
    addClientToGroup: 'Ajouter un Client au Groupe',
    noGroups: 'Aucun groupe disponible pour ajouter un client.',
    noClients: 'Aucun client disponible pour ajouter au groupe.',
    groupName: 'Nom du Groupe',
    descriptionOptional: 'Description (facultative)',
    selectGroup: 'Sélectionner un groupe',
    selectClient: 'Sélectionner un client',
    addGroup: 'Ajouter Groupe',
    addClients: 'Ajouter Clients',
    uploading: 'Téléchargement en cours...',
    successfullyAdded: 'Ajout réussi de',
    clientsToGroups: 'clients aux groupes',
    csvUploadFailed: 'Échec du téléchargement du CSV. Veuillez réessayer.',
    or: 'ou',
    selectCsvToAddInBulk: 'Télécharger un CSV pour ajouter en masse',
    csvHeaders: 'Le fichier CSV doit contenir les en-têtes suivants :',
    csvRequiredColumns:
      'Seulement les colonnes country et phone_number sont obligatoires.',
    groupCreatedSuccessfully: 'Groupe créé avec succès !',
    errorCreatingGroup: 'Erreur lors de la création du groupe...',
    groupNameSuccessfullyUpdated: 'Nom du groupe mis à jour avec succès en',
    errorUpdatingGroupName: 'Erreur lors de la mise à jour du nom du groupe',
    descriptionSuccessfullyUpdated: 'Description mise à jour avec succès pour',
    errorUpdatingDescription:
      'Erreur lors de la mise à jour de la description pour',
    clientsLowercase: 'clients',
    emptyGroup: 'Ce groupe est vide...',
    noGroupsYet: "Cette organisation n'a pas encore ajouté de groupes.",
    successfullyDeletedGroup: 'Suppression réussie du groupe',
    errorDeletingGroup: 'Erreur lors de la suppression du groupe',
    viewClients: 'Voir les Clients',
    totalClients: 'Clients Totaux',
    addedAt: 'Ajouté',
    addedBy: 'Ajouté par',
    errorFetchingClients:
      'Erreur lors de la récupération des clients du groupe...',
    searchGroup: 'Rechercher des groupes...',
    removeFromGroup: 'Retirer du groupe',
    remove: 'Retirer',
    confirmRemoveClient:
      'Êtes-vous sûr de vouloir retirer ce client du groupe ?',
    clientRemoved: 'Client retiré du groupe',
    errorRemovingClient: 'Échec du retrait du client',
  },
  templates: {
    viewAndSendTemplates: 'Envoyer Messages',
    allTemplates: 'Tous les Modèles',
    refresh: 'Actualiser',
    showApprovedOnly: 'Afficher uniquement les modèles approuvés',
    noTemplatesFound: 'Aucun modèle trouvé...',
    templateDetails: 'Détails du Modèle',
    selectTemplate:
      'Sélectionnez un modèle pour voir les détails ou envoyer un message',
    selectTemplateToPreview: 'Sélectionnez un modèle pour voir un aperçu',
    template: 'Modèle',
    notApproved: "Ce modèle n'est actuellement pas approuvé.",
    pendingApproval: "Ce modèle est en attente d'approbation...",
    templatePaused:
      'Ce modèle a été mis en pause par Meta en raison de sa faible qualité ou de retours négatifs élevés.',
    templateDisabled: 'Ce modèle a été désactivé par Meta.',
    templateLimitExceeded: 'Ce modèle a dépassé sa limite de messages.',
    statusApproved: 'Approuvé',
    statusPending: 'En attente',
    statusRejected: 'Rejeté',
    statusPaused: 'En pause',
    statusDisabled: 'Désactivé',
    statusLimitExceeded: 'Limite dépassée',
    statusInAppeal: 'En appel',
    statusDeleting: 'Suppression',
    statusDeleted: 'Supprimé',
    selectDifferentImage: 'Sélectionner une autre image',
    selectDifferentVideo: 'Sélectionner une autre vidéo',
    editHeaderParameters: "Modifier les paramètres de l'en-tête",
    editBodyParameters: 'Modifier les paramètres du corps',
    messagePreview: 'Aperçu du Message',
    templatePreview: 'Aperçu du Modèle',
    previewNotExact:
      "L'apparence finale du message peut différer de l'aperçu selon l'appareil du destinataire.",
    buttons: 'Boutons',
    sendTemplate: 'Envoyer le Modèle',
    sendMessage: 'Envoyer un message',
    backToTemplates: 'Modèles',
    close: 'Fermer',
    sendingFrom: 'Envoyé depuis:',
    selectPhoneNumber: "Sélectionner un numéro de téléphone pour l'envoi",
    selectRecipients: 'Sélectionner les destinataires',
    sendTo: 'Envoyer le modèle à:',
    organization: 'Organisation',
    groups: 'Groupes',
    clients: 'Clients',
    phones: 'Numéros de téléphone',
    selectGroup: 'Sélectionner un groupe',
    selectClient: 'Sélectionner un client',
    enterPhoneNumber: 'Saisissez le numéro de téléphone',
    add: 'Ajouter',
    theTemplateMessage: 'Le message du modèle',
    templateWillBeSentToOrg:
      "sera envoyé à tous les destinataires dans l'organisation",
    templateWillBeSentToGroup:
      'sera envoyé à tous les destinataires dans le groupe',
    send: 'Envoyer',
    sendNow: 'Envoyer maintenant',
    schedule: 'Planifier',
    scheduleMessage: 'Planifier le message',
    scheduledFor: 'Planifié pour',
    selectDateTime: "Sélectionner la date et l'heure",
    scheduleFor: 'Planifier pour :',
    sendOrSchedule: 'Envoyer ou planifier le message',
    scheduledSuccessfully: 'Message planifié avec succès !',
    errorScheduling: 'Erreur lors de la planification du message...',
    dateTimeMustBeFuture: "L'heure planifiée doit être dans le futur",
    cancelScheduledMessage: 'Annuler le message planifié',
    cancelSchedule: 'Annuler la planification',
    cancelScheduleConfirmation:
      'Êtes-vous sûr de vouloir annuler ce message planifié ? Cette action est irréversible.',
    viewScheduledMessages: 'Voir les messages planifiés',
    scheduledMessages: 'Messages planifiés',
    noScheduledMessages: 'Aucun message planifié',
    scheduled: 'Planifié',
    canceled: 'Annulé',
    scheduleCanceled: 'Planification annulée avec succès',
    errorCanceling: "Erreur lors de l'annulation de la planification...",
    errorFetchingScheduledMessages:
      'Erreur lors de la récupération des messages planifiés...',
    scheduledDescription: "Messages en attente d'envoi à l'heure prévue.",
    scheduledSentDescription:
      'Messages planifiés qui ont été envoyés avec succès.',
    scheduledCanceledDescription:
      "Messages planifiés qui ont été annulés avant l'envoi.",
    scheduledFailedDescription:
      "Messages planifiés qui n'ont pas pu être envoyés en raison d'une erreur.",
    allScheduledMessages: 'Tous les messages planifiés',
    scheduledTime: 'Heure prévue',
    audience: 'Destinataires',
    repeatMessage: 'Répéter',
    repeatsColumn: 'Récurrence',
    pause: 'Mettre en pause',
    resume: 'Reprendre',
    scheduledStatusPaused: 'En pause',
    scheduledStatusCompleted: 'Terminé',
    recurrenceFrequency: 'Fréquence',
    recurrenceDaily: 'Quotidien',
    recurrenceWeekly: 'Hebdomadaire',
    recurrenceMonthly: 'Mensuel',
    recurrenceDayOfMonth: 'Jour du mois',
    recurrenceDayOfMonthHint:
      'Limité à 28 pour éviter les ambiguïtés de février et des mois à 30/31 jours.',
    recurrenceTimeOfDay: 'Heure de la journée',
    recurrenceTimeOfDayHint: 'HH:mm (24 heures)',
    recurrenceTimezone: 'Fuseau horaire',
    recurrenceEnds: 'Se termine',
    recurrenceEndsNever: 'Jamais',
    recurrenceEndsOn: 'À une date',
    recurrenceEndsAfter: 'Après N occurrences',
    recurrenceEndDate: 'Date de fin',
    recurrenceEndCount: "Nombre d'occurrences",
    recurrencePreview: 'Aperçu',
    recurrenceOccurrences: 'Occurrences',
    recurrenceEveryDay: 'Chaque jour',
    recurrenceEvery: 'Chaque',
    recurrenceAt: 'à',
    recurrenceMonthlyOnDay: 'Le',
    weekdaySun: 'Dim',
    weekdayMon: 'Lun',
    weekdayTue: 'Mar',
    weekdayWed: 'Mer',
    weekdayThu: 'Jeu',
    weekdayFri: 'Ven',
    weekdaySat: 'Sam',
    viewOccurrenceHistory: "Voir l'historique",
    invalidRecurrenceError:
      'Les paramètres de récurrence sont incomplets ou invalides. Vérifiez l’heure, le choix des jours ou le jour du mois.',
    occurrenceHistoryTitle: 'Historique des occurrences',
    occurrenceHistoryEmpty: 'Aucune occurrence pour le moment.',
    occurrenceWhen: 'Quand',
    occurrenceError: 'Erreur',
    loadMore: 'Charger plus',
    pausedSuccessfully: 'Planification mise en pause',
    errorPausing: 'Erreur lors de la mise en pause',
    resumedSuccessfully: 'Planification reprise',
    errorResuming: 'Erreur lors de la reprise',
    onTheWay: "Votre message est en cours d'envoi...",
    viewSentMessages: 'Voir les messages envoyés',
    errorSending: "Erreur lors de l'envoi du message...",
    createTemplate: 'Créer un Modèle',
    templateNameAndLanguage: 'Nom et langue du modèle',
    nameYourTemplate:
      'Nommez votre modèle (minuscules et tirets bas uniquement)',
    selectLanguage: 'Sélectionner la langue',
    french: 'Français',
    english: 'Anglais',
    category: 'Catégorie',
    selectCategory: 'Sélectionner la catégorie',
    content: 'Contenu',
    contentSubtitle:
      "Remplissez les sections d'en-tête, corps et pied de page de votre modèle.",
    header: 'En-tête',
    enterHeaderText: "Saisir le texte d'en-tête",
    selectHeaderType: "Sélectionner le type d'en-tête",
    selectHeaderImage: "Sélectionner l'image d'en-tête",
    selectHeaderVideo: "Sélectionner la vidéo d'en-tête",
    changeImage:
      "Vous pourrez modifier l'image lors de l'envoi du message du modèle.",
    changeVideo:
      "Vous pourrez modifier la vidéo lors de l'envoi du message du modèle.",
    samplesForHeader: "Exemples pour l'en-tête",
    samplesForBody: 'Exemples pour le corps',
    exampleForEachHeaderVariable:
      "Veuillez ajouter un exemple pour chaque variable dans votre texte d'en-tête. N'utilisez pas de vraies informations client.",
    exampleForEachBodyVariable:
      "Veuillez ajouter un exemple pour chaque variable dans votre texte de corps. N'utilisez pas de vraies informations client.",
    tooManyBodyVars:
      'Trop de variables pour le corps. Veuillez en supprimer quelques-unes ou augmenter la longueur du texte.',
    none: 'Aucun',
    text: 'Texte',
    image: 'Image',
    video: 'Vidéo',
    body: 'Corps',
    enterBodyText: 'Saisir le texte du corps',
    footer: 'Pied de page',
    enterFooterText: 'Saisir le texte du pied de page',
    optional: 'Facultatif',
    buttonsSubtitle:
      "Créez des boutons permettant aux clients de répondre à votre message ou d'agir. Vous pouvez ajouter jusqu'à 10 boutons.",
    addButton: 'Ajouter',
    create: 'Créer',
    creating: 'Le modèle est en cours de création...',
    createdSuccessfully: 'Modèle créé avec succès !',
    errorCreating: 'Erreur lors de la création du modèle...',
    pleaseEnterTemplateName: 'Veuillez saisir un nom de modèle',
    pleaseEnterBody: 'Veuillez saisir le corps du message',
    pleaseUploadMedia:
      "Veuillez télécharger une image ou une vidéo pour l'en-tête",
    pleaseFillAllVariables: 'Veuillez remplir tous les exemples de variables',
    pleaseFillRequiredFields: 'Veuillez remplir tous les champs obligatoires',
    language: 'Langue',
    sentMessages: 'Messages Envoyés',
    byGroup: 'Par Groupe',
    byClient: 'Par Client',
    byTemplate: 'Par Modèle',
    byOrg: 'Par Organisation',
    goBack: 'Retour',
    confirm: 'Confirmer',
    name: 'Nom',
    total: 'Total',
    queued: 'En attente',
    processing: 'En cours',
    stuck: 'Coincé',
    outbound: 'Sortant',
    sent: 'Envoyé',
    delivered: 'Livré',
    read: 'Lu',
    failed: 'Échoué',
    lastSent: 'Dernier envoi',
    noMessagesYet: 'Aucun message envoyé pour le moment...',
    searchClients: 'Rechercher des clients...',
    searchTemplates: 'Rechercher des modèles...',
    noMessagesFound: 'Aucun message trouvé...',
    templateName: 'Nom du Modèle',
    sentAt: 'Envoyé à',
    status: 'Statut',
    lastUpdated: 'Dernière mise à jour',
    errors: 'Erreurs',
    errorFetchingMessagesForClient:
      'Erreur lors de la récupération des messages pour le client...',
    messagesByStatus: 'Messages par Statut',
    messageVolumeTrend: 'Volume Quotidien de Messages',
    totalMessages: 'Total des Messages',
    activeTemplates: 'Modèles Actifs',
    deliveryRate: 'Taux de Livraison',
    activeRecipients: 'Destinataires Actifs',
    totalMessagesOrgDesc:
      'Nombre total de messages modèles envoyés par cette organisation sur toutes les périodes.',
    activeTemplatesDesc:
      'Nombre de modèles de messages uniques qui ont été utilisés au cours des 30 derniers jours.',
    deliveryRateDesc:
      'Pourcentage de messages envoyés, livrés ou lus (taux de succès) parmi tous les messages terminés (réussis + échoués/bloqués).',
    period: 'Période',
    days7: '7 jours',
    days30: '30 jours',
    days90: '90 jours',
    all: 'Tout',
    compare: 'Comparer',
    activeClients: 'Clients actifs',
    totalMessagesLabel: 'Messages totaux',
    successRate: 'Taux de succès',
    failures: 'Échecs',
    activeClientsDesc:
      'Nombre de clients uniques ayant reçu au moins un message modèle.',
    totalMessagesDesc:
      'Nombre total de messages modèles envoyés à tous les clients et modèles.',
    successRateDesc:
      'Pourcentage de messages qui ont été envoyés, livrés ou lus avec succès. Cela exclut les messages qui ont échoué ou sont bloqués.',
    failuresDesc:
      "Nombre de messages qui n'ont pas pu être envoyés ou qui sont bloqués lors du traitement.",
    currentPeriod: 'Période actuelle',
    previousPeriod: 'Période précédente',
    noDataAvailable: 'Aucune donnée disponible pour cette période',
    failuresAndErrors: 'Échecs / Erreurs',
    error: 'Erreur',
    errorCode: "Code d'erreur",
    errorCategoryMeta: 'Erreur API WhatsApp',
    errorCategoryTechnical: 'Erreur Technique',
    errorCategoryUnknown: 'Erreur Inconnue',
    moreErrors: 'autre(s) erreur(s)',
    numberOfMessages: 'Nombre de messages',
    deliveryFunnel: 'Entonnoir de Livraison des Messages',
    readRate: 'Taux de Lecture',
    overallReadRate: 'Taux de Lecture Global',
    messageCount: 'Messages',
    topPerformingTemplates: 'Modèles les Plus Performants',
    successRatePercent: 'Taux de Succès (%)',
    comingSoon: 'Bientôt disponible...',
    notifications: 'Notifications',
    confirmDeleteTitle: 'Confirmer la suppression',
    deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer ce modèle ?',
    cancel: 'Annuler',
    delete: 'Supprimer',
    deletingTemplate: 'Suppression du modèle en cours...',
    templateSuccessfullyDeleted: 'Modèle supprimé avec succès !',
    errorDeletingTemplate: 'Erreur lors de la suppression du modèle...',
    loading: 'Chargement...',
    enterButtonText: 'Saisir le texte du bouton',
    quickReply: 'Réponse rapide',
    phoneNumberButton: 'Numéro de téléphone',
    urlButton: 'Lien URL',
    copyCode: 'Copier le code',
    buttonPhoneNumberPlaceholder: 'Numéro de téléphone (ex: +221771234567)',
    buttonUrlPlaceholder: "Entrez l'URL",
    buttonCodePlaceholder: 'Code à copier',
    categoryMarketing: 'Marketing',
    categoryUtility: 'Utilitaire',
    categoryAuthentication: 'Authentification',
    couponCode: 'Code promo',
    enterCouponCode: 'Entrez le code promo',
    buttonParameters: 'Paramètres des boutons',
    messageValidityPeriod: 'Période de validité du message',
    validityPeriodDescription1:
      "Vous pouvez définir une période de validité personnalisée pendant laquelle votre message utilitaire doit être livré avant d'expirer. Si un message n'est pas livré dans ce délai, vous ne serez pas facturé et votre client ne verra pas le message.",
    validityPeriodDescription2:
      "Si vous ne définissez pas de période de validité personnalisée, la période standard de 30 jours de WhatsApp s'appliquera.",
    setCustomValidityPeriod:
      'Définir une période de validité personnalisée pour votre message',
    variables: 'Variables',
    variableTypeTitle: 'Type de variable',
    variableTypeDescription:
      'Les variables sont des espaces réservés qui servent à insérer dynamiquement des informations ou des données spécifiques dans votre modèle. Vous pouvez insérer soit un nom, soit un numéro comme variable.',
    examples: 'Exemples :',
    variableNameExample: 'Nom : {{order_id}}',
    variableNumberExample: 'Numéro : {{1}}',
    variableTypeNumber: 'Numéro',
    variableTypeNamed: 'Nommé',
    minuteSingular: 'minute',
    minutesPlural: 'minutes',
    // Conversation drawer
    conversation: 'Conversation',
    conversationTemplates: 'Modèles',
    conversationClientReplies: 'Réponses du client',
    conversationBotResponses: 'Réponses du bot',
    conversationAgentMessages: 'Agent',
    messageTypeTemplate: 'Modèle',
    messageTypeClient: 'Client',
    messageTypeBot: 'Bot',
    messageTypeAgent: 'Agent',
    timeNow: 'maintenant',
    noMessagesInConversation: 'Aucun message dans cette conversation',
    noMessagesMatchFilters:
      'Aucun message ne correspond aux filtres sélectionnés',
    sessionActive: 'Actif',
    sessionActiveTooltip:
      'Le contact a envoyé un message dans les dernières 24h — les réponses libres sont possibles',
    marketingDeliveryTip:
      'Les messages marketing peuvent avoir un taux de livraison plus faible. Les contacts ayant déjà interagi avec votre entreprise sont plus susceptibles de les recevoir.',
    copyOptInLink: "Copier le lien d'inscription",
    optInLinkCopied: 'Copié !',
    previewTemplate: 'Aperçu',
    startTypingToPreview: "Commencez à taper pour voir l'aperçu",
    viewHistory: "Voir l'Historique de Conversation",
    conversationHistory: 'Historique de Conversation',
    // Field mapping for personalized parameters
    switchToStatic: 'Utiliser la même valeur pour tous',
    switchToField: 'Personnaliser par destinataire',
    selectClientField: 'Sélectionner le champ client',
    fieldMayBeEmpty: 'Peut être vide pour certains destinataires',
    emptyFieldValue: '(vide)',
    phoneDisabledWithFieldMapping:
      'Les numéros de téléphone ne peuvent pas être utilisés avec des champs personnalisés',
    fieldFirstName: 'Prénom',
    fieldLastName: 'Nom',
    fieldMiddleName: 'Deuxième prénom',
    fieldPhoneNumber: 'Numéro de téléphone',
    fieldEmail: 'Email',
    previewRecipients: 'Aperçu',
    noClientsFound: "Aucun client trouvé pour l'aperçu",
  },
  api: {
    apiDocumentation: "Documentation de l'API",
    apiDocumentationDescription:
      "Explorez divers exemples d'utilisation de l'API dans différents langages de programmation pour intégrer rapidement l'API dans votre application.",
    apiSettings: "Paramètres de l'API",
    apiSettingsDescription:
      'Gérez vos clés API et paramètres pour une intégration transparente.',
    apiCredentials: 'Identifiants API',
    apiKey: 'Clé API',
    apiKeyDescription:
      "Votre clé API est utilisée pour authentifier les requêtes vers l'API. Gardez-la secrète et sécurisée.",
    copiedApiKey: 'Clé API copiée',
    copyApiKeyError: 'Erreur lors de la copie de la clé API',
    generateNewApiKey: 'Générer une nouvelle clé API',
    oldKeyWillBeInvalidated:
      "L'ancienne clé sera invalidée si vous en générez une nouvelle.",
    apiInformation: "Informations sur l'API",
    currentVersion: 'Version Actuelle',
    currentVersionDescription: 'Dernière version avec performances améliorées',
    viewApiDocumentation: "Voir la documentation de l'API",
    viewDocumentationDescription:
      "Trouver des guides d'intégration et des exemples de code",
    sdkInformation: 'Informations sur le SDK',
    viewSdkDocumentation: 'Voir la documentation du SDK',
    requestHeaders: 'En-têtes de Requête',
    requestBody: 'Corps de la Requête',
    exampleFunction: "Exemple d'intégration",
    exampleUsage: "Exemple d'utilisation",
    in: 'en',
    sendNotification: 'Envoyer Notification',
    sendNotificationDescription:
      'Envoyer un message modèle pré-approuvé à une liste de destinataires',
    loadError: 'Échec du chargement de la documentation API',
    loadErrorDescription:
      "La documentation API n'a pas pu être chargée. Veuillez vérifier votre connexion et réessayer.",
  },
  subscriptionBanner: {
    trialActive: 'Votre essai se termine le {date}.',
    trialEndingSoon: 'Votre essai se termine dans {days} {dayUnit} ({date}).',
    renewalComing: 'Votre abonnement se renouvelle le {date}.',
    appsCancelling: 'Annulation de {apps} au prochain renouvellement ({date}).',
    gracePeriod:
      'Paiement en retard. Payez avant le {date} pour garder vos apps actives.',
    expired:
      'Votre abonnement a expiré. Réabonnez-vous pour retrouver l\u2019accès.',
    payNow: 'Payer maintenant',
    managePlan: 'Gérer le forfait',
    restore: 'Rétablir',
    trialExpired:
      'Votre essai est terminé. Abonnez-vous pour continuer à utiliser vos apps.',
    subscribe: "S'abonner",
  },
  export: {
    title: 'Exporter les données',
    description:
      'Exportez les données de votre organisation au format CSV ou JSON. Les exports volumineux seront traités en arrière-plan.',
    lockedMessage:
      "Souscrivez à l'option Export de données pour exporter les données de votre organisation.",
    selectData: 'Sélectionner les données à exporter',
    selectAll: 'Tout sélectionner',
    clients: 'Clients',
    groups: 'Groupes (y compris les membres)',
    templates: 'Modèles',
    messages: 'Messages (envoyés, reçus, bot)',
    imminoteApiUsage: "Utilisation de l'API Imminote",
    botFlows: 'Flux de bot',
    format: "Format d'export",
    csv: 'CSV',
    json: 'JSON',
    exportButton: 'Exporter les données',
    exporting: 'Exportation en cours...',
    exportQueued:
      'Votre export est en cours de traitement. Vous recevrez un email lorsque celui-ci sera prêt.',
    exportReady: 'Export prêt à télécharger',
    downloadExport: 'Télécharger',
    rateLimitWarning:
      "Vous ne pouvez exporter qu'une fois toutes les 24 heures",
    nextAvailableAt: 'Prochain export disponible le',
    exportHistory: "Historique d'export",
    noExports: "Pas encore d'exports",
    status: 'Statut',
    requestedAt: 'Demandé le',
    completedAt: 'Terminé le',
    fileSize: 'Taille',
    actions: 'Actions',
    pending: 'En attente',
    processing: 'En cours',
    completed: 'Terminé',
    failed: 'Échoué',
    asyncNote:
      'Les exports contenant des messages sont traités en arrière-plan. Vous recevrez un email lorsque votre export sera prêt.',
    selectAtLeastOne:
      'Veuillez sélectionner au moins un type de données à exporter',
    exportSuccess: 'Export terminé avec succès',
    exportError: "L'export a échoué. Veuillez réessayer.",
    upgradeRequired:
      "L'export de données est disponible sur les forfaits supérieurs",
    adminOnly: 'Seuls les administrateurs peuvent exporter les données',
    stillProcessing:
      'Votre export est toujours en cours de traitement. Veuillez réessayer dans quelques instants.',
    jobNotFound: 'Export introuvable. Il a peut-être expiré ou été supprimé.',
  },
  erasure: {
    title: 'Suppression de données',
    description:
      "Demandez la suppression définitive des données personnelles d'un client ou d'un utilisateur. Les demandes ont un délai de grâce de 30 jours avant exécution.",
    entityType: 'Type',
    client: 'Client',
    user: 'Utilisateur',
    selectClient: 'Sélectionner un client',
    selectUser: 'Sélectionner un utilisateur',
    searchPlaceholder: 'Rechercher par nom, téléphone ou email...',
    requestErasure: 'Demander la suppression',
    forceErase: 'Supprimer immédiatement',
    confirmRequestTitle: 'Confirmer la demande de suppression',
    confirmRequestMessage:
      'Cela programmera la suppression définitive de toutes les données personnelles de cette entité après le délai de grâce de 30 jours. Cette action peut être annulée pendant le délai de grâce.',
    confirmForceTitle: 'Suppression immédiate',
    confirmForceMessage:
      'Cela va IMMÉDIATEMENT et DÉFINITIVEMENT supprimer toutes les données personnelles de cette entité. Cette action est irréversible.',
    confirmForceCheckbox: 'Je comprends que cette action est irréversible',
    pending: 'En attente',
    executing: 'En cours',
    completed: 'Terminé',
    canceled: 'Annulé',
    failed: 'Échoué',
    requestHistory: 'Demandes de suppression',
    status: 'Statut',
    type: 'Type',
    entity: 'Entité',
    requestedBy: 'Demandé par',
    requestedAt: 'Demandé le',
    gracePeriodEndsAt: 'Fin du délai de grâce',
    executedAt: 'Exécuté le',
    actions: 'Actions',
    cancel: 'Annuler',
    cancelSuccess: 'Demande de suppression annulée',
    requestSuccess:
      'Demande de suppression créée. Les données seront définitivement supprimées après le délai de grâce de 30 jours.',
    forceSuccess: 'Les données ont été définitivement supprimées',
    alreadyPending:
      'Une demande de suppression est déjà en cours pour cette entité',
    notFound: 'Entité introuvable',
    superadminRequired: 'Accès superadmin requis pour la suppression immédiate',
    noRequests: 'Aucune demande de suppression',
    daysRemaining: 'jours restants',
  },
  rakine: {
    modules: {
      overview: 'Aperçu',
      overviewDesc: 'Livreurs actifs, livraisons et résumé des revenus',
      drivers: 'Livreurs',
      driversDesc: 'Gérer les livreurs',
      deliveries: 'Livraisons',
      deliveriesDesc: 'Suivre et gérer les livraisons',
      dispatch: 'Expédition',
      dispatchDesc: 'Créer et assigner des livraisons',
      settings: 'Paramètres',
      settingsDesc: 'Tarification et types de véhicules',
      solarboxCustomers: 'Clients payants',
      solarboxCustomersDesc: 'Abonnés Solarbox et historique des paiements',
      solarboxBikeControl: 'Contrôle vélos',
      solarboxBikeControlDesc:
        'Verrouiller ou déverrouiller un vélo Solarbox par code QR',
    },
    overview: {
      title: 'Aperçu',
      activeDrivers: 'Livreurs Actifs',
      activeDriversDesc:
        'Livreurs enregistrés dans votre organisation, hors ceux qui ne se sont jamais connectés.',
      available: 'Disponible',
      availableDesc:
        'Livreurs actuellement en ligne et disponibles pour accepter des livraisons.',
      offline: 'Hors ligne',
      offlineDesc: 'Livreurs enregistrés actuellement hors ligne.',
      delivering: 'En livraison',
      deliveringDesc: 'Livreurs actuellement en cours de livraison.',
      totalDeliveries: 'Total des Livraisons',
      totalDeliveriesDesc:
        'Nombre total de livraisons terminées pour votre organisation.',
      thisMonth: 'Ce mois',
      completed: 'Terminées',
      completedDesc:
        'Livraisons terminées ce mois-ci (le livreur a récupéré et livré avec succès).',
      total: 'Total',
      totalDesc:
        'Toutes les livraisons démarrées ce mois-ci, quel que soit leur statut actuel.',
      completionRate: 'Taux de complétion',
      completionRateDesc:
        'Pourcentage de livraisons démarrées ce mois-ci qui ont été terminées. Calculé comme Terminées / Total.',
      noData: 'Aucune donnée de livraison disponible',
      trackDelivery: 'Suivre une livraison',
      searchPlaceholder: "Entrer l'ID de la commande",
      search: 'Rechercher',
      notFound: 'Livraison introuvable',
      pickup: 'Enlèvement',
      destination: 'Destination',
      driver: 'Livreur',
      requester: 'Demandeur',
      recipient: 'Destinataire',
      price: 'Prix',
      distance: 'Distance',
      duration: 'Durée',
      started: 'Début',
      ended: 'Fin',
      createdAt: 'Créée le',
      photoProof: 'Photo de preuve',
      view: 'Voir',
      status: 'Statut',
      fetchError: 'Échec du chargement des détails de livraison',
      overviewFetchError: "Échec du chargement de l'aperçu",
      retry: 'Réessayer',
      alertsTitle: 'Alertes de livraison',
      stuck: 'Bloquée',
      failed: 'Échouée',
      stuckFor: 'Bloquée depuis',
      noAlerts: 'Aucune alerte de livraison',
      leaderboard: 'Classement des livreurs',
      byDeliveries: 'Par livraisons',
      byAvailability: 'Par disponibilité',
      availabilityComingSoon: 'Bientôt disponible',
      rank: '#',
      driverName: 'Livreur',
      lbDeliveries: 'Livraisons',
      revenue: 'Revenus',
      avgTime: 'Temps moy.',
      lbRate: 'Taux',
      week: 'Semaine',
      month: 'Mois',
      allTime: 'Tout',
      noDriverData: 'Aucune donnée de livreur disponible',
      leaderboardError: 'Échec du chargement du classement',
      onlineTime: 'Temps en ligne',
      deliveringTime: 'En livraison',
      daysActive: 'Jours actifs',
      deliveryTrends: 'Tendances des livraisons',
      peakHours: 'Heures de pointe',
      last7Days: '7 jours',
      last30Days: '30 jours',
      last90Days: '90 jours',
      cancelled: 'Annulées',
      trendFailed: 'Échouées',
      trendDeliveries: 'Livraisons',
      noTrendData: 'Aucune donnée de livraison pour cette période',
      demandZones: 'Zones de demande',
      demandZonesDesc: 'Zones avec le plus de demandes de livraison',
      noHotspotData: 'Aucune donnée de point de retrait pour cette période',
      hotspotsFetchError: 'Échec du chargement des zones de demande',
    },
    deliveryDetail: {
      back: 'Retour aux livraisons',
      fetchError: 'Impossible de charger les détails de la livraison',
      reassignDriver: 'Réassigner un livreur',
      cancelDelivery: 'Annuler la livraison',
      cancelDeliveryConfirm:
        'Êtes-vous sûr de vouloir annuler cette livraison ?',
      cancelDeliverySuccess: 'Livraison annulée',
      cancelDeliveryError: "Échec de l'annulation de la livraison",
      cannotCancelDelivery: "Impossible d'annuler une livraison déjà en cours",
    },
    drivers: {
      title: 'Livreurs',
      list: 'Liste',
      map: 'Carte',
      name: 'Nom',
      phone: 'Téléphone',
      status: 'Statut',
      vehicleType: 'Type de véhicule',
      lastUpdated: 'Dernière mise à jour',
      noDrivers: 'Aucun livreur trouvé pour cette organisation',
      available: 'Disponible',
      offline: 'Hors ligne',
      delivering: 'En livraison',
      all: 'Tous',
      lastSeen: 'Vu',
      search: 'Rechercher par nom ou téléphone',
      clearFilters: 'Effacer les filtres',
      fetchError: 'Échec du chargement des livreurs',
      liveTracking: 'Suivi en direct',
      lowRatedDrivers: 'Livreurs mal notés',
      lowRatedDriversDescription:
        'Les livreurs suivants ont une note moyenne inférieure à 3 étoiles',
      avgRating: 'moy',
    },
    driverDetail: {
      title: 'Détails du livreur',
      back: 'Retour aux livreurs',
      profile: 'Profil',
      phone: 'Téléphone',
      vehicleType: 'Type de véhicule',
      status: 'Statut',
      totalDeliveries: 'Total des livraisons',
      totalEarnings: 'Revenus totaux',
      averageRating: 'Note moyenne',
      ratingsCount: 'Évaluations',
      deliveryHistory: 'Historique des livraisons',
      noDeliveries: 'Aucune livraison trouvée pour ce livreur',
      fetchError: 'Échec du chargement des détails du livreur',
      location: 'Position',
      lastSeen: 'Vu',
      historyTab: 'Historique',
      ratingsTab: 'Évaluations',
      noRatings: 'Aucune évaluation',
      ratingDistribution: 'Répartition des notes',
      recentRatings: 'Évaluations récentes',
      noComment: 'Pas de commentaire',
      activityTab: 'Activité',
      onlineTime: 'Temps en ligne',
      deliveringTime: 'Temps en livraison',
      daysActive: 'Jours actifs',
      dailyBreakdown: 'Répartition journalière',
      noActivityData: "Aucune donnée d'activité disponible",
      activityError: "Échec du chargement des données d'activité",
    },
    deliveries: {
      title: 'Livraisons',
      id: 'ID',
      status: 'Statut',
      route: 'Itinéraire',
      price: 'Prix',
      driver: 'Livreur',
      date: 'Date',
      noDeliveries: 'Aucune livraison trouvée',
      fetchError: 'Échec du chargement des livraisons',
      completed: 'Terminée',
      pending: 'En attente',
      accepted: 'Acceptée',
      atPickup: 'Au point de collecte',
      pickedUp: 'Collectée',
      rejected: 'Refusée',
      cancelled: 'Annulée',
      noDeliverer: 'Sans livreur',
      clearFilters: 'Effacer les filtres',
      rateDelivery: 'Évaluer cette livraison',
      ratingLabel: 'Évaluation',
      commentPlaceholder: 'Ajouter un commentaire (optionnel)',
      submitRating: 'Soumettre',
      ratedOn: 'Évalué le',
      ratingError: "Erreur lors de l'envoi de l'évaluation",
      dateRange: 'Période',
      clearDates: 'Effacer les dates',
    },
    settings: {
      title: 'Paramètres',
      pricing: 'Tarification',
      pricingDesc: 'Définir le prix de livraison par type de véhicule (FCFA)',
      moto: 'Moto',
      tricycle: 'Tricycle',
      vehicleTypes: 'Types de véhicules',
      vehicleTypesDesc:
        'Choisir les types de véhicules disponibles pour les livraisons',
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      saveSuccess: 'Paramètres enregistrés',
      saveError: "Échec de l'enregistrement des paramètres",
      fetchError: 'Échec du chargement des paramètres',
    },
    dispatch: {
      title: 'Expédition',
      subtitle: 'Créer une livraison et assigner un livreur',
      stepDetails: 'Détails de la livraison',
      stepReview: 'Vérifier le devis',
      stepDriver: 'Assigner un livreur',
      stepDone: 'Terminé',
      pickupLocation: 'Lieu de collecte',
      pickupPlaceholder: 'Rechercher une adresse',
      dropoffLocation: 'Lieu de dépôt',
      dropoffPlaceholder: 'Rechercher une adresse',
      noResults: 'Aucun résultat',
      geocodingCountry: 'Pays pour le géocodage',
      mapHint:
        'Cliquez sur la carte pour placer un repère, ou faites glisser le repère existant pour ajuster.',
      mapPlacePinHint: 'Cliquez pour placer un repère',
      requesterSection: 'Demandeur (expéditeur)',
      requesterName: 'Nom du demandeur',
      requesterPhone: 'Téléphone du demandeur',
      recipientSection: 'Destinataire',
      recipientName: 'Nom du destinataire',
      recipientPhone: 'Téléphone du destinataire',
      sameAsRequester: 'Identique au demandeur',
      vehicleType: 'Type de véhicule',
      moto: 'Moto',
      tricycle: 'Tricycle',
      instructions: 'Instructions (optionnel)',
      instructionsPlaceholder: 'Étage, code de porte, manipulation spéciale…',
      back: 'Retour',
      next: 'Suivant',
      getQuote: 'Obtenir un devis',
      gettingQuote: 'Calcul du devis…',
      reviewTitle: 'Vérifier le devis',
      price: 'Prix',
      priceOriginal: 'Prix initial',
      priceOverride: 'Modifier le prix si besoin',
      eta: 'Temps estimé',
      etaMinutes: 'minutes',
      continueToDriver: 'Continuer vers le livreur',
      updatingPrice: 'Mise à jour du prix…',
      driverTitle: 'Choisir un livreur',
      availableOnly: 'Disponibles uniquement',
      allDrivers: 'Tous les livreurs',
      noAvailableDrivers: 'Aucun livreur disponible',
      refreshDrivers: 'Actualiser',
      selectDriver: 'Sélectionner un livreur',
      sendProposition: 'Envoyer la proposition',
      sending: 'Envoi…',
      autoSearch: 'Recherche auto',
      searching: 'Recherche…',
      propositionSentTitle: 'Proposition envoyée',
      waitingForDriver: 'En attente de la confirmation de {name}…',
      autoSearchPending: 'Recherche de livreurs disponibles…',
      dispatchFailed: 'Échec de la course',
      dispatchFailedHelp:
        "Aucun livreur n'a accepté cette course. Vous pouvez réessayer avec un autre livreur ou utiliser la recherche auto.",
      quotationId: 'ID de la livraison',
      targetedDriver: 'Livreur ciblé',
      acceptedDriver: 'Accepté par',
      viewDelivery: 'Voir la livraison',
      newDispatch: 'Nouvelle expédition',
      errorQuote: 'Échec de la création du devis',
      errorPriceUpdate: 'Échec de la mise à jour du prix',
      errorPropose: "Échec de l'envoi de la proposition",
      errorAutoSearch: 'Échec du démarrage de la recherche',
      errorFetchDrivers: 'Échec du chargement des livreurs',
      errorDriverUnavailable: "Le livreur n'est plus disponible",
      errorDriverNoToken: 'Livreur injoignable (pas de notification push)',
      errorRequiredFields: 'Veuillez remplir tous les champs requis',
      errorPhoneFormat: 'Numéro de téléphone invalide',
      errorMapboxToken: 'Token Mapbox non configuré',
      listView: 'Liste',
      mapView: 'Carte',
      pickupMarker: 'Collecte',
      stillWaiting: 'En attente de la réponse du livreur...',
      stillSearching: "Recherche d'un livreur disponible...",
    },
    solarbox: {
      title: 'Clients payants',
      phoneNumber: 'Numéro de téléphone',
      displayName: 'Nom',
      customerSince: 'Client depuis',
      lastPaid: 'Dernier paiement',
      noCustomers: "Aucun client payant pour l'instant",
      fetchError: 'Échec du chargement des clients',
      detail: {
        title: 'Détails du client',
        phoneNumberLabel: 'Numéro',
        displayNameLabel: "Nom d'affichage",
        displayNamePlaceholder: 'ex. Mamadou D.',
        displayNameTooLong: 'Maximum 80 caractères',
        saveButton: 'Enregistrer',
        clearButton: 'Effacer',
        labelSetBy: 'défini par {email} · {date}',
        registeredAt: 'Client depuis',
        lastPaidAt: 'Dernier paiement',
        recentActivityHeading: 'Activité récente',
        noActivity: 'Aucune activité au cours des 90 derniers jours',
        activityOtherGroup: 'Autres événements',
        activityFailureBadge: 'échec',
        activityEventCount: '{count} événements',
        activityExpandAria: 'Déplier {label}',
        activityCollapseAria: 'Replier {label}',
        loadError: 'Échec du chargement des détails',
        saveError: "Échec de l'enregistrement",
      },
      bikeControl: {
        title: 'Contrôle des vélos',
        subtitle: 'Verrouille ou déverrouille un vélo Solarbox par code QR.',
        qrIdLabel: 'Code QR',
        qrIdHint: 'ex. SB10057',
        paymentReferenceLabel: 'Référence de paiement (optionnelle)',
        paymentReferenceHint:
          "Associe l'action au client dans le journal d'audit.",
        reasonLabel: 'Motif (optionnel)',
        reasonHint: "Visible dans l'événement d'activité.",
        reasonPlaceholder: 'ex. vélo bloqué signalé par le client',
        lockButton: 'Verrouiller',
        unlockButton: 'Déverrouiller',
        confirmTitle: "Confirmer l'action",
        confirmBody: 'Voulez-vous vraiment {action} {qrId} ?',
        confirmCancel: 'Annuler',
        confirmDispatch: 'Envoyer',
        resultSucceeded: 'Action réussie',
        resultFailed: 'Échec de l’action',
        resultQrLabel: 'QR',
        resultDeviceLabel: 'ID appareil',
        resultErrorLabel: 'Erreur',
        resetButton: 'Nouvelle action',
        requestError: "Échec de l'envoi de l'action",
      },
    },
  },
  imminote: {
    modules: {
      parametres: 'Paramètres',
      parametresDesc: "Gérez les clés API et l'authentification",
      messages: 'Messages',
      messagesDesc: "Envoyez des modèles et consultez l'historique",
      apiDocs: 'Documentation API',
      apiDocsDesc: "Explorez la référence API et les guides d'intégration",
    },
    tabs: {
      integration: 'Intégration',
      integrationDesc: 'Générateur de code interactif',
      api: 'API',
      apiDesc: "Documentation de l'API",
      createTemplate: 'Créer un modèle',
      scheduled: 'Planifiés',
      scheduledDesc: 'Voir et gérer les messages planifiés',
      history: 'Historique',
      historyDesc:
        "Historique des messages et statistiques d'utilisation de l'API",
    },
    integration: {
      description:
        "Générez des extraits de code pour intégrer l'API Imminote dans votre application",
      selectTemplate: 'Sélectionnez un modèle',
      template: 'Modèle',
      apiConfig: "Configuration de l'API",
      apiConfigDesc: 'Configurez les paramètres de la requête API',
      apiKey: 'Clé API',
      apiKeyHelp: 'Votre clé API Imminote depuis les Paramètres',
      recipients: 'Destinataires',
      recipientsHelp: 'Sélectionnez un indicatif et saisissez le numéro local',
      add: 'Ajouter',
      phoneNumberId: 'ID du numéro de téléphone',
      scheduleMessage: 'Planifier pour plus tard',
      scheduledSendTime: 'Envoyer à',
      parameters: 'Paramètres du modèle',
      parametersDesc:
        "Modifiez ces valeurs d'exemple pour les voir reflétées dans l'extrait de code",
      headerParams: "Paramètres d'en-tête",
      bodyParams: 'Paramètres du corps',
      codeSnippet: 'Extrait de code',
      copied: 'Code copié dans le presse-papiers',
      selectTemplatePrompt:
        'Sélectionnez un modèle ci-dessus pour générer des extraits de code',
    },
    apiDocs: {
      description:
        'Référence API complète pour envoyer des messages de modèle WhatsApp',
      endpoint: 'Point de terminaison',
      authentication: 'Authentification',
      authDesc:
        "Toutes les requêtes doivent inclure une clé API dans l'en-tête Authorization",
      rateLimits: 'Limites de débit',
      currentPlan: 'Votre plan actuel',
      rateLimitsDesc:
        "Le nombre maximum de destinataires par appel API est basé sur votre plan d'abonnement",
      maxRecipients: 'Max de destinataires par requête',
      upgradePrompt:
        "Besoin d'envoyer à plus de destinataires ? Mettez à niveau votre plan dans Paramètres.",
      requestFormat: 'Format de requête',
      requestFormatDesc: 'Structure du corps de requête JSON',
      field: 'Champ',
      type: 'Type',
      required: 'Requis',
      fieldDescription: 'Description',
      recipientsDesc: 'Tableau de numéros de téléphone au format E.164',
      phoneNumberIdDesc: 'Votre ID de numéro de téléphone WhatsApp Business',
      templateNameDesc: 'Nom du modèle approuvé à envoyer',
      languageDesc: 'Code de langue du modèle (ex: "en", "fr")',
      componentsDesc: 'Paramètres du modèle (en-tête, corps, boutons)',
      example: 'Exemple de requête',
      responseFormat: 'Format de réponse',
      successResponse: 'Réponse de succès (200)',
      errorResponse: "Réponse d'erreur (429)",
      errorCodes: "Codes d'erreur",
      code: 'Code',
      code200: 'Succès - Messages envoyés avec succès',
      code400: 'Mauvaise requête - Paramètres de requête invalides',
      code401: 'Non autorisé - Clé API invalide ou manquante',
      code403: 'Interdit - Modèle non disponible ou abonnement inactif',
      code404: 'Non trouvé - Modèle ou organisation non trouvé(e)',
      code429:
        'Limite de débit dépassée - Trop de destinataires pour votre plan',
      code500: 'Erreur interne du serveur',
      scheduling: 'Planification de messages',
      schedulingDesc:
        "Planifiez des messages pour un envoi futur en ajoutant le champ scheduled_send_time à votre requête d'envoi.",
      scheduledSendTimeDesc:
        "Date ISO 8601 pour l'envoi planifié. Si omis, le message est envoyé immédiatement.",
      schedulingRequest: 'Planifier un message',
      schedulingResponse: 'Réponse de planification (201)',
      listScheduled: 'Lister les messages planifiés',
      cancelScheduled: 'Annuler un message planifié',
    },
    scheduled: {
      description:
        "Voir et gérer les messages planifiés créés via l'API Imminote",
      title: 'Messages planifiés',
      allStatuses: 'Tous les statuts',
      statusScheduled: 'Planifié',
      statusSent: 'Envoyé',
      statusCanceled: 'Annulé',
      statusFailed: 'Échoué',
      templateColumn: 'Modèle',
      recipientsColumn: 'Destinataires',
      scheduledForColumn: 'Planifié pour',
      statusColumn: 'Statut',
      createdColumn: 'Créé',
      actionsColumn: 'Actions',
      cancel: 'Annuler',
      noMessages: 'Aucun message planifié',
      noMessagesDesc:
        "Les messages planifiés via l'API Imminote apparaîtront ici",
    },
    apiKeys: {
      title: 'Clés API',
      description:
        "Gérez les clés API pour authentifier les requêtes vers l'API Imminote",
      generate: 'Générer une nouvelle clé',
      revoke: 'Révoquer',
      active: 'Active',
      revoked: 'Révoquée',
      revokedKeys: 'Clés révoquées',
      revokedOn: 'Révoquée',
      keyColumn: 'Clé',
      nameColumn: 'Nom',
      createdColumn: 'Créée',
      lastUsedColumn: 'Dernière utilisation',
      statusColumn: 'Statut',
      actionsColumn: 'Actions',
      neverUsed: 'Jamais',
      noKeys: 'Aucune clé API pour le moment',
      generateFirst: 'Générez votre première clé API pour commencer',
      generateTitle: 'Générer une nouvelle clé API',
      generateButton: 'Générer',
      nameLabel: 'Nom de la clé (optionnel)',
      namePlaceholder: 'ex: Serveur de production',
      nameDescription:
        "Donnez un nom à votre clé API pour l'identifier facilement plus tard (optionnel)",
      saveWarning:
        'Assurez-vous de copier votre clé API maintenant. Vous ne pourrez plus la voir !',
      generated: 'Clé API générée avec succès',
      copied: 'Clé API copiée dans le presse-papiers',
      confirmRevoke:
        'Êtes-vous sûr de vouloir révoquer cette clé API ? Cette action est irréversible.',
      fetchError: 'Échec de la récupération des clés API',
      generateError: 'Échec de la génération de la clé API',
      revokeError: 'Échec de la révocation de la clé API',
      copyError: 'Échec de la copie de la clé API',
    },
    history: {
      description:
        "Consultez l'historique des messages et les statistiques d'utilisation de l'API",
      messageHistory: 'Historique des messages',
      apiUsageStats: "Statistiques d'utilisation de l'API",
      filters: 'Filtres',
      status: 'Statut',
      template: 'Modèle',
      allStatuses: 'Tous les statuts',
      allTemplates: 'Tous les modèles',
      recipientColumn: 'Destinataire',
      templateColumn: 'Modèle',
      statusColumn: 'Statut',
      sentAtColumn: 'Envoyé',
      noMessages: 'Aucun message pour le moment',
      noMessagesDesc:
        "Les messages envoyés via l'API Imminote apparaîtront ici",
      overallStats: 'Statistiques globales',
      last30Days: '30 derniers jours',
      last7Days: '7 derniers jours',
      totalCalls: 'Total des appels API',
      successfulCalls: 'Appels réussis',
      failedCalls: 'Appels échoués',
      totalRecipients: 'Total des destinataires',
      callsByApiKey: 'Appels par clé API',
      callsOverTime: 'Appels API dans le temps',
      mostUsedTemplates: 'Modèles les plus utilisés',
      keyColumn: 'Clé API',
      callsColumn: 'Appels',
      recipientsColumn: 'Destinataires',
      successRateColumn: 'Taux de réussite',
      templateNameColumn: 'Modèle',
      usageCountColumn: "Nombre d'utilisations",
      noApiKeys: 'Aucune donnée de clé API',
      noTemplateUsage: "Aucune donnée d'utilisation de modèle",
      successRate: 'Taux de réussite',
      noUsageData: "Aucune donnée d'utilisation de l'API pour le moment",
      noUsageDataDescription:
        "Les statistiques d'utilisation apparaîtront ici une fois que vous commencerez à effectuer des appels API",
    },
  },
  sdk: {
    comingSoon: 'Bientôt disponible...',
  },
  botFlows: {
    // List page
    title: 'Flux de Bot',
    description: 'Créez et gérez vos flux de chatbot',
    subtitle:
      'Créez et gérez des flux de conversation automatisés pour votre chatbot',
    createNew: 'Créer un Flux',
    emptyTitle: 'Aucun flux pour le moment',
    emptyDescription:
      'Créez votre premier flux de bot pour commencer à automatiser les conversations',
    createFirst: 'Créer le Premier Flux',
    published: 'Publié',
    draft: 'Brouillon',
    lastModified: 'Dernière modification',
    flowName: 'Nom du Flux',
    // Templates
    selectTemplate: 'Choisir un modèle',
    blankTemplate: 'Vide',
    blankTemplateDesc: 'Commencer de zéro avec un flux vide',
    customerSupportTemplate: 'Support Client',
    customerSupportTemplateDesc:
      'Gérer les commandes, retours et demandes générales',
    faqBotTemplate: 'Bot FAQ',
    faqBotTemplateDesc: 'Répondre aux questions courantes avec un menu',
    appointmentTemplate: 'Prise de Rendez-vous',
    appointmentTemplateDesc:
      'Collecter les informations et planifier des rendez-vous',
    // Editor
    unsavedChanges: 'Modifications non enregistrées',
    test: 'Tester',
    publish: 'Publier',
    steps: 'Étapes',
    stepsOrderInfo:
      "Glissez pour réorganiser. L'ordre est uniquement pour l'organisation et n'affecte pas la logique du flux.",
    searchSteps: 'Rechercher des étapes...',
    noSearchResults: 'Aucune étape ne correspond à votre recherche',
    addStep: 'Ajouter une Étape',
    noSteps:
      'Aucune étape pour le moment. Ajoutez votre première étape pour commencer à construire le flux.',
    addFirstStep: 'Ajouter la Première Étape',
    selectStep: 'Sélectionnez une étape à modifier',
    editStep: "Modifier l'Étape",
    stepName: "Nom de l'Étape",
    // Action types
    actionType: "Type d'Action",
    actionTypes: {
      buttons: 'Boutons',
      text: 'Message Texte',
      list: 'Menu Liste',
      locationRequest: 'Demander la Localisation',
      mediaRequest: 'Demander un Média',
      whatsappFlow: 'Flux WhatsApp',
      end: 'Terminer la Conversation',
    },
    // Message content
    messageContent: 'Contenu du Message',
    messageBody: 'Corps du Message',
    messageBodyPlaceholder: 'Saisissez le message à envoyer...',
    buttons: 'Boutons',
    addButton: 'Ajouter un Bouton',
    autoAdvanceTo: 'Avancer automatiquement vers',
    // Transitions
    transitions: 'Transitions',
    addTransitionFor: 'Ajouter une transition pour',
    addResponseHandler: 'Ajouter un Gestionnaire de Réponse',
    onLocationReceived: 'À la réception de la localisation',
    onMediaReceived: 'À la réception du média',
    // Fallback
    fallback: 'Comportement de Repli',
    fallbackDescription:
      "Ce qui se passe lorsque l'utilisateur envoie un message inattendu",
    fallbackMessage: 'Message de Repli',
    fallbackAction: 'Action de Repli',
    repeatStep: 'Répéter cette étape',
    goToStep: "Aller à l'étape",
    // Entry point
    entryPoint: 'Entrée',
    setAsEntry: "Définir comme Point d'Entrée",
    duplicateStep: 'Dupliquer',
    stepNotReachable: "L'étape n'est pas accessible depuis le point d'entrée",
    // Toasts
    loadError: 'Échec du chargement du flux',
    saveSuccess: 'Flux enregistré avec succès',
    saveError: "Échec de l'enregistrement du flux",
    publishSuccess: 'Flux publié avec succès',
    publishValidationError:
      'Impossible de publier : le flux contient des erreurs de validation',
    publishError: 'Échec de la publication du flux',
    publishNoPhoneNumber:
      'Veuillez attribuer un numéro de téléphone avant de publier',
    // Phone number
    phoneNumber: 'Numéro de Téléphone',
    noPhoneNumber: 'Non attribué',
    phoneNumberUpdated: 'Numéro de téléphone mis à jour',
    phoneNumberUpdateError: 'Échec de la mise à jour du numéro de téléphone',
    createError: 'Échec de la création du flux',
    deleteSuccess: 'Flux supprimé avec succès',
    deleteError: 'Échec de la suppression du flux',
    duplicateSuccess: 'Flux dupliqué avec succès',
    duplicateError: 'Échec de la duplication du flux',
    compileError: 'Échec de la compilation du flux',
    compileValidationError:
      'Impossible de compiler: Veuillez vous assurer que toutes les transitions ont une étape cible sélectionnée',
    yamlCopied: 'YAML copié dans le presse-papiers',
    // YAML
    viewYaml: 'Voir YAML',
    // Validation errors
    validationErrorsTitle: 'Erreurs de Validation',
    validationErrorsDescription:
      'Veuillez corriger les problèmes suivants avant de compiler :',
    clickToEdit: 'Cliquez pour modifier',
    // Publish confirmation
    publishConfirmTitle: 'Publier le Flux',
    publishConfirmMessage:
      'Êtes-vous sûr de vouloir publier ce flux ? Il deviendra actif immédiatement.',
    // Simulator
    simulatorSubtitle: 'Mode Test',
    conversationEnded: 'Conversation terminée',
    typeMessage: 'Écrivez un message...',
    restartSimulation: 'Recommencer',
    // View modes
    listView: 'Vue Liste',
    graphView: 'Vue Graphique',
  },
  users: {
    users: 'Utilisateurs',
    viewUsers: 'Voir les Utilisateurs',
    search: 'Rechercher des utilisateurs...',
    searchResultsEmpty: 'Aucun utilisateur trouvé...',
    admin: 'administrateur',
    created: 'Créé le:',
    lastUpdated: 'Dernière mise à jour:',
    grantAdminPrivileges: 'Accorder les privilèges administrateur',
    revokeAdminPrivileges: 'Révoquer les privilèges administrateur',
    addUsers: 'Ajouter des Utilisateurs',
    bulkAddUsersToOrg: "Ajout en masse d'Utilisateurs à l'Organisation",
    addUserToOrg: "Ajouter un Utilisateur à l'Organisation",
    email: 'Email',
    isAdmin: 'Administrateur',
    shouldSendEmail: 'Envoyer une invitation par email',
    uploadCsv: 'Télécharger CSV',
    addUser: 'Ajouter Utilisateur',
    noUsersYet: "Cette organisation n'a pas encore ajouté d'utilisateurs.",
    userRoleSuccessfullyUdated:
      "Rôle de l'utilisateur mis à jour avec succès !",
    errorUpdatingUserRole:
      "Erreur lors de la mise à jour du rôle de l'utilisateur...",
    bulkUsersAddedSuccessfully: 'Utilisateurs ajoutés en masse avec succès !',
    errorAddingUsersInBulk:
      "Erreur lors de l'ajout des utilisateurs en masse...",
    userAddedSuccessfully: "Utilisateur ajouté à l'organisation avec succès !",
    errorAddingUser:
      "Erreur lors de l'ajout de l'utilisateur à l'organisation...",
    successfullyAdded: 'Ajout réussi de',
    usersToOrg: "utilisateurs à l'organisation.",
    uploading: 'Téléchargement en cours...',
    csvUploadError: 'Échec du téléchargement du CSV. Veuillez réessayer.',
    selectCsvToAdd: 'Télécharger un CSV pour ajouter des utilisateurs',
    csvHeaders: 'Le fichier CSV doit contenir les en-têtes suivants :',
    csvRequiredColumns:
      'Les colonnes username (email) et role sont obligatoires. Le rôle doit être "admin" ou "user".',
  },
  modals: {
    confirmDeleteTitle: 'Confirmer la suppression',
    deleteConfirmation: 'Êtes-vous sûr ?',
    cancel: 'Annuler',
    delete: 'Supprimer',
  },
  common: {
    uploadFile: 'Télécharger un Fichier',
    dragDropFile: 'Glissez-déposez un fichier ici, ou cliquez pour parcourir',
    readyToUpload: 'Prêt à télécharger',
    noName: '<aucun nom>',
    clientNotAvailable: "Ce client n'est pas disponible",
    groupNotAvailable: "Ce groupe n'est pas disponible",
    userNotAvailable: "Cet utilisateur n'est pas disponible",
    templateNotAvailable: "Ce modèle n'est pas disponible",
    goBack: 'Retour',
    confirm: 'Confirmer',
    confirmCancellation: "Confirmer l'annulation",
    upgradeRequired: 'Mise à niveau requise',
    upgradeToAccess:
      'Pour accéder à cette fonctionnalité, veuillez mettre à niveau votre abonnement.',
    viewPlans: 'Voir les forfaits',
    gotIt: 'Compris',
    enterpriseFeature: 'Fonctionnalité Enterprise',
    watchDemo: 'Voir la démo',
    hideDemo: 'Masquer la démo',
    save: 'Enregistrer',
    cancel: 'Annuler',
    create: 'Créer',
    retry: 'Réessayer',
    creating: 'Création en cours...',
    delete: 'Supprimer',
    duplicate: 'Dupliquer',
    copy: 'Copier',
    close: 'Fermer',
    beta: 'Bêta',
  },
  refresh: {
    lastUpdated: 'Dernière mise à jour',
    refreshing: 'Actualisation...',
    refreshNow: 'Réactualiser',
    justNow: "à l'instant",
    minutesAgo: 'm',
    hoursAgo: 'h',
    daysAgo: 'j',
    never: 'jamais',
  },
  demos: {
    title: 'Démonstrations',
    subtitle:
      'Regardez des démonstrations interactives pour découvrir comment notre plateforme peut aider votre entreprise.',
    uiNotice:
      "Ces démos montrent une version antérieure de notre interface. La plateforme actuelle bénéficie d'un design amélioré.",
    backToHome: "Retour à l'accueil",
    comingSoon: 'Démos à venir. Revenez plus tard !',
    viewDemos: 'Voir les démos',
  },
  faq: {
    title: 'Questions Fréquemment Posées',
    subtitle:
      'Trouvez des réponses aux questions courantes sur notre plateforme, WhatsApp Business et les politiques de Meta.',
    viewAllFaqs: 'Voir toutes les FAQ',
    sections: [
      {
        title: 'Livraison des Messages',
        questions: [
          {
            question: "Pourquoi mon message n'a-t-il pas été livré ?",
            answer:
              "Les messages peuvent échouer pour plusieurs raisons :\n\n• Le destinataire a bloqué votre numéro professionnel\n• Le numéro de téléphone est invalide ou n'est plus actif sur WhatsApp\n• Vous avez essayé d'envoyer un message libre en dehors de la fenêtre de service client de 24 heures\n• Votre modèle a été rejeté ou suspendu par Meta\n• Le destinataire n'a pas accepté de recevoir des messages de votre entreprise\n\nVérifiez le statut du message dans votre tableau de bord pour plus de détails.",
          },
          {
            question:
              "Qu'est-ce que la fenêtre de service client de 24 heures ?",
            answer:
              "Lorsqu'un client envoie un message à votre entreprise, une fenêtre de 24 heures s'ouvre pendant laquelle vous pouvez envoyer des messages libres (texte, images, documents) sans utiliser de modèles approuvés. Après la fermeture de cette fenêtre, vous devez utiliser des modèles de messages pré-approuvés pour initier de nouvelles conversations. C'est une politique de Meta conçue pour prévenir le spam.",
          },
          {
            question: 'Quelle est la différence entre le statut Livré et Lu ?',
            answer:
              "• Envoyé : Le message a quitté nos serveurs\n• Livré : Le message est arrivé sur l'appareil du destinataire\n• Lu : Le destinataire a ouvert et consulté le message (affiché uniquement s'il a activé les accusés de lecture)\n\nRemarque : Certains utilisateurs désactivent les accusés de lecture, donc un message peut être lu sans afficher le statut 'Lu'.",
          },
          {
            question: 'Puis-je garantir la livraison des messages ?',
            answer:
              'Aucune plateforme ne peut garantir une livraison à 100%. La livraison dépend de facteurs hors de notre contrôle, notamment :\n\n• Si le destinataire a WhatsApp installé\n• La connectivité réseau\n• La disponibilité des serveurs Meta/WhatsApp\n• Les paramètres de confidentialité du destinataire\n\nNous fournissons des accusés de réception pour que vous puissiez suivre les messages livrés avec succès.',
          },
          {
            question:
              'Pourquoi les messages marketing ont-ils un taux de livraison plus faible ?',
            answer:
              "Meta limite le nombre de messages marketing que chaque utilisateur WhatsApp peut recevoir de l'ensemble des entreprises. Cela signifie :\n\n• Un utilisateur qui reçoit déjà beaucoup de messages marketing d'autres entreprises peut ne pas recevoir les vôtres\n• Meta peut choisir de ne pas livrer votre message pour protéger l'expérience utilisateur (erreur 131049)\n• Les utilisateurs peuvent individuellement refuser les messages marketing de votre entreprise (erreur 131050)\n\nPour améliorer les taux de livraison :\n\n• Envoyez aux contacts qui ont déjà échangé avec votre entreprise\n• Gardez les messages marketing pertinents et peu fréquents\n• Utilisez les modèles Utilitaire pour les messages transactionnels (mises à jour de commande, rappels) — ceux-ci ne sont pas soumis aux limites marketing",
          },
        ],
      },
      {
        title: 'Politiques Meta & Conformité',
        questions: [
          {
            question: 'Qui décide si mes messages sont livrés ?',
            answer:
              "Meta (la société mère de WhatsApp) a le dernier mot sur la livraison des messages. Ils exploitent des systèmes de détection de spam qui peuvent bloquer ou limiter les messages qu'ils considèrent comme indésirables. En tant que fournisseur de solutions WhatsApp Business, nous facilitons l'envoi de messages, mais Meta contrôle finalement la plateforme WhatsApp et applique ses politiques.",
          },
          {
            question: 'Quels types de messages Meta interdit-il ?',
            answer:
              "Meta interdit :\n\n• Le spam ou les messages en masse non sollicités\n• Les messages sans consentement approprié de l'utilisateur\n• Le contenu trompeur ou mensonger\n• Le contenu pour adultes ou les produits/services illégaux\n• Les messages qui violent la politique commerciale de WhatsApp\n• Le harcèlement ou les messages menaçants\n\nVioler ces politiques peut entraîner le bannissement de votre numéro.",
          },
          {
            question:
              "Comment fonctionne le processus d'approbation des modèles ?",
            answer:
              "Lorsque vous créez un modèle de message :\n\n1. Soumettez le modèle via notre plateforme\n2. Meta l'examine (généralement en quelques minutes à 24 heures)\n3. Les modèles sont approuvés, rejetés ou signalés pour examen\n\nLes raisons courantes de rejet incluent le contenu promotionnel dans les modèles utilitaires, les variables manquantes ou les violations de politique. Vous pouvez modifier et resoumettre les modèles rejetés.",
          },
          {
            question:
              'Quelle est la différence entre les modèles Marketing, Utilitaire et Authentification ?',
            answer:
              "• Marketing : Messages promotionnels, offres, newsletters, annonces de produits. Nécessite un consentement explicite.\n\n• Utilitaire : Messages transactionnels comme les confirmations de commande, mises à jour d'expédition, rappels de rendez-vous. Liés à une transaction existante.\n\n• Authentification : Mots de passe à usage unique (OTP) et codes de vérification uniquement.\n\nChaque catégorie a des tarifs et critères d'approbation différents.",
          },
          {
            question: 'Que se passe-t-il si mon numéro WhatsApp est banni ?',
            answer:
              "Si Meta bannit votre numéro, vous perdrez la possibilité d'envoyer des messages depuis ce numéro. Les causes courantes incluent :\n\n• Taux élevé de signalements de spam par les destinataires\n• Envoi à des utilisateurs qui n'ont pas donné leur consentement\n• Violations des politiques de modèles\n• Comportements de messagerie anormaux\n\nVous pouvez faire appel via le Centre d'aide Meta Business, mais la réintégration n'est pas garantie. Nous recommandons de maintenir de bonnes pratiques de messagerie pour éviter les bannissements.",
          },
          {
            question: 'Ai-je besoin du consentement des destinataires ?',
            answer:
              "Oui, Meta exige que vous obteniez le consentement avant d'envoyer des messages WhatsApp aux clients. Cela signifie :\n\n• Les clients doivent accepter activement de recevoir des messages\n• Vous devez expliquer clairement quels messages ils recevront\n• Vous devez fournir un moyen facile de se désabonner\n\nConservez les preuves de consentement. Envoyer des messages sans consentement viole les politiques de Meta et peut entraîner la restriction ou le bannissement de votre numéro.",
          },
        ],
      },
      {
        title: 'Tarification & Facturation',
        questions: [
          {
            question: "Comment fonctionne l'essai gratuit ?",
            answer:
              "Il y a un essai gratuit de 14 jours. Vous aurez un accès complet à toutes les fonctionnalités du plan de base jusqu'à l'expiration de la période d'essai. Aucune carte de crédit ou engagement requis.",
          },
          {
            question: 'Puis-je changer de forfait plus tard ?',
            answer:
              'Oui, vous pouvez passer à un forfait supérieur ou inférieur à tout moment. Votre nouveau forfait et ses fonctionnalités seront actifs à partir de votre prochaine période de facturation. Votre forfait actuel reste actif jusque-là.',
          },
          {
            question: 'Quels modes de paiement acceptez-vous ?',
            answer:
              'Nous acceptons les paiements par carte, Orange Money et Wave Money. Les clients Enterprise peuvent explorer des options de paiement supplémentaires.',
          },
          {
            question:
              'Que se passe-t-il si je dépasse les limites de mon forfait ?',
            answer:
              'Nous vous avertirons lorsque vous approcherez de vos limites. Vous pouvez passer à un forfait supérieur ou nous contacter pour une solution personnalisée.',
          },
          {
            question: 'Offrez-vous des remboursements ?',
            answer:
              "Vous pouvez annuler votre abonnement à tout moment depuis les paramètres de votre profil. Si vous avez des préoccupations ou des problèmes, contactez notre équipe d'assistance - nous serons heureux de discuter de votre situation et d'explorer les options au cas par cas.",
          },
          {
            question: 'Comment fonctionne la tarification Dabsi ?',
            answer:
              'Nous offrons des options de tarification flexibles pour répondre à vos besoins :\n\n• Pay As You Go : Payez par message envoyé. Les messages modèles (Marketing, Utilitaire, Authentification) sont facturés séparément par type, et les messages non-modèles sont facturés individuellement. Les tarifs varient selon le pays du destinataire.\n\n• Forfaits Mensuels : Coût mensuel fixe avec crédits de messages inclus et fonctionnalités supplémentaires.\n\nLes prix sont susceptibles de changer. Consultez notre page de tarification pour les tarifs et détails des forfaits actuels.',
          },
          {
            question: 'Offrez-vous des réductions pour les associations ?',
            answer:
              'Oui, nous offrons des tarifs spéciaux pour les organisations à but non lucratif enregistrées. Contactez notre équipe commerciale pour plus de détails.',
          },
        ],
      },
      {
        title: 'Technique & API',
        questions: [
          {
            question: "Quelles sont les limites de débit de l'API ?",
            answer:
              "Les forfaits avec accès API complet (Pay as you go, Professional et Enterprise) incluent une limite de débit de 100 messages par seconde. Cela s'applique à l'API d'envoi pour envoyer des messages WhatsApp de manière programmatique. Si vous avez besoin d'un débit plus élevé, contactez notre équipe commerciale pour une solution personnalisée.",
          },
          {
            question: 'Quelle est la fiabilité des webhooks ?',
            answer:
              "Nous livrons les webhooks avec une garantie de livraison au moins une fois. Cela signifie :\n\n• Les webhooks peuvent occasionnellement être livrés plus d'une fois\n• Votre endpoint doit gérer les événements en double (utilisez les ID de message pour la déduplication)\n• Si votre endpoint est indisponible, nous réessayons avec un backoff exponentiel (jusqu'à 3 tentatives)\n\nAssurez-vous que votre endpoint webhook répond rapidement avec un statut 200 pour éviter les timeouts.",
          },
          {
            question:
              'De quel numéro de téléphone ai-je besoin pour WhatsApp Business ?',
            answer:
              "Vous avez besoin d'un numéro de téléphone qui :\n\n• Peut recevoir des SMS ou appels vocaux pour la vérification\n• N'est pas déjà enregistré sur WhatsApp ou l'application WhatsApp Business\n• Est sous votre contrôle/propriété\n\nVous pouvez utiliser une ligne fixe (vérifiée par appel vocal) ou un numéro mobile. Une fois enregistré avec l'API, vous ne pouvez plus utiliser ce numéro avec les applications WhatsApp classiques.",
          },
          {
            question: 'Puis-je utiliser plusieurs numéros de téléphone ?',
            answer:
              "Oui, selon votre forfait. Les forfaits Professional et Enterprise prennent en charge plusieurs numéros de téléphone. Chaque numéro nécessite une vérification séparée et peut avoir son propre nom d'affichage et profil. C'est utile pour différentes marques, départements ou régions.",
          },
        ],
      },
      {
        title: 'Compte & Configuration',
        questions: [
          {
            question: "Comment démarrer avec l'API WhatsApp Business ?",
            answer:
              "1. Inscrivez-vous pour un compte Dabsi\n2. Connectez votre compte Facebook Business\n3. Créez ou sélectionnez un compte WhatsApp Business (WABA)\n4. Ajoutez et vérifiez votre numéro de téléphone\n5. Complétez la vérification d'entreprise (si nécessaire)\n6. Commencez à créer des modèles et envoyer des messages\n\nLe processus d'inscription intégré et les vidéos de démonstration vous guident à chaque étape.",
          },
          {
            question:
              "Qu'est-ce que la vérification d'entreprise et en ai-je besoin ?",
            answer:
              "La vérification d'entreprise confirme l'identité de votre entreprise auprès de Meta. Elle est requise pour :\n\n• Envoyer plus de 250 messages par jour\n• Accéder à certaines fonctionnalités\n• Afficher un nom d'entreprise vérifié\n\nLa vérification nécessite de soumettre des documents d'entreprise (immatriculation, factures de services publics, etc.) et prend généralement 2 à 5 jours ouvrables.",
          },
          {
            question:
              "Quelles directives dois-je suivre pour le nom d'affichage ?",
            answer:
              'Votre nom d\'affichage WhatsApp doit :\n\n• Représenter fidèlement votre entreprise\n• Ne pas contenir d\'informations trompeuses\n• Ne pas inclure de mots génériques comme "Marketing" ou "Notifications" seuls\n• Ne pas violer de marques déposées\n• Être cohérent avec votre documentation d\'entreprise\n\nMeta examine les noms d\'affichage et peut rejeter ceux qui ne respectent pas les directives.',
          },
          {
            question:
              "Qu'advient-il de mes données si je rétrograde ou annule mon abonnement ?",
            answer:
              "Lorsque vous rétrogradez, les clients, groupes et modèles excédentaires au-delà des limites de votre nouveau forfait passent en mode lecture seule. Vous pouvez toujours voir toutes les données, mais ne pouvez pas envoyer de messages aux éléments excédentaires jusqu'à ce que vous passiez à un forfait supérieur.\n\nLorsque vous annulez, vos données sont conservées pendant 30 jours au cas où vous réactiveriez. Après 30 jours, les données peuvent être définitivement supprimées conformément à notre politique de conservation des données.",
          },
        ],
      },
      {
        title: 'Confidentialité & RGPD',
        questions: [
          {
            question: 'Que se passe-t-il quand je supprime un client ?',
            answer:
              "Lorsque vous supprimez un client de votre organisation, le client est supprimé de manière réversible — l'enregistrement est masqué de votre vue active mais les données restent dans le système. Cela vous permet de restaurer le client si la suppression était accidentelle.\n\nLes données supprimées de manière réversible ne sont pas définitivement effacées sauf si vous soumettez explicitement une demande d'effacement des données.",
          },
          {
            question: "Qu'est-ce qu'une demande d'effacement des données ?",
            answer:
              "Une demande d'effacement des données est une requête formelle pour supprimer de manière permanente et irréversible toutes les données personnelles associées à un client ou utilisateur. Cela inclut :\n\n• Les détails du client (nom, numéro de téléphone, e-mail)\n• Le contenu des messages et les numéros de téléphone dans l'historique des messages\n• Les paramètres des messages programmés\n• Les entrées de journal d'audit associées\n\nUne fois exécuté, les données ne peuvent pas être récupérées. Les enregistrements de messages sont conservés à des fins d'analyse mais avec toutes les données personnelles remplacées par [REDACTED].",
          },
          {
            question:
              "Comment fonctionne le délai de grâce pour l'effacement ?",
            answer:
              "Lorsqu'un administrateur soumet une demande d'effacement des données, elle entre dans un délai de grâce de 30 jours. Pendant cette période :\n\n• La demande est marquée comme en attente\n• Un administrateur peut annuler la demande à tout moment\n• Aucune donnée n'est supprimée\n\nAprès l'expiration du délai de grâce de 30 jours, l'effacement est automatiquement exécuté par notre système. Ce délai de grâce protège contre la suppression accidentelle ou prématurée des données.",
          },
          {
            question: 'Puis-je demander un effacement immédiat des données ?',
            answer:
              "Oui, les super-administrateurs de l'organisation peuvent forcer un effacement immédiat, contournant le délai de grâce de 30 jours. Cela nécessite une confirmation explicite et est prévu pour les cas où les données doivent être supprimées de toute urgence (par exemple, une demande formelle d'effacement RGPD d'une personne concernée).\n\nL'effacement immédiat est irréversible — les données sont définitivement supprimées dès son exécution.",
          },
          {
            question:
              "Qui peut soumettre ou annuler une demande d'effacement ?",
            answer:
              "Seuls les administrateurs et super-administrateurs de l'organisation peuvent soumettre des demandes d'effacement des données. Les administrateurs peuvent également annuler les demandes en attente pendant le délai de grâce.\n\nL'effacement immédiat (forcé) sans délai de grâce est réservé aux super-administrateurs uniquement.",
          },
          {
            question: 'Comment mes données sont-elles sécurisées ?',
            answer:
              "Vos données sont protégées par plusieurs niveaux de sécurité : chiffrement au repos et en transit, contrôles d'accès basés sur les rôles, authentification sécurisée et un journal d'audit complet de tous les accès et modifications de données. Nous effectuons des revues de sécurité régulières et suivons les meilleures pratiques de l'industrie en matière de sécurité applicative et d'infrastructure.",
          },
          {
            question: 'Dabsi est-il conforme au RGPD ?',
            answer:
              "Oui. Notre plateforme prend en charge le droit à l'effacement du RGPD (Article 17) grâce à notre système de demandes d'effacement des données. Lorsqu'une personne concernée demande la suppression de ses données personnelles, un administrateur peut soumettre une demande d'effacement qui supprime définitivement toutes les données personnelles de nos systèmes.\n\nNotre plateforme respecte également la loi sénégalaise sur la protection des données personnelles (Loi n°2008-12). Toutes les actions d'effacement sont enregistrées à des fins d'audit et de conformité. Contactez-nous à contact@dabsi.io pour toute question relative à la protection des données.",
          },
        ],
      },
    ],
  },
  privacy: {
    title: 'Politique de Confidentialité',
    intro:
      "Cette Politique de Confidentialité s'applique à la plateforme Dabsi. Nous nous engageons à protéger votre vie privée et à traiter vos données de manière responsable.",
    sections: {
      introduction: {
        title: 'Introduction',
        content:
          'Nous accordons une grande importance à votre vie privée, en particulier dans le cadre des activités en ligne. Cette Politique de Confidentialité décrit comment nous traitons les informations des utilisateurs de notre plateforme, y compris les visiteurs et les clients enregistrés.',
      },
      roles: {
        title: 'Rôles dans le Traitement des Données',
        content:
          'Les données que nous stockons dépendent du service que vous utilisez. Pour les services de relais et de transfert (où les messages sont transmis à vos systèmes backend), vous agissez en tant que Responsable du traitement et DABSI agit en tant que Sous-traitant, ne conservant que des données transitoires minimales. Pour les produits gérés comme Clientell, nous stockons les informations clients (noms, numéros de téléphone, historique des messages) selon les besoins du service.',
      },
      pii: {
        title: "Qu'est-ce qu'une Information Personnellement Identifiable ?",
        content:
          "« Information Personnellement Identifiable » désigne toute information permettant d'identifier, de contacter ou de localiser une personne, comme un nom, une adresse, un numéro de téléphone, une adresse e-mail ou une adresse IP. Cela n'inclut pas les informations collectées de manière anonyme ou les données démographiques non liées à une personne identifiée.",
      },
      collect: {
        title: 'Informations que Nous Collectons',
        content:
          "Nous pouvons collecter des informations de profil de base auprès de tous les visiteurs et les informations supplémentaires suivantes auprès des clients enregistrés : nom, adresse e-mail, numéro de téléphone, adresse IP et informations commerciales telles que la nature et la taille de l'entreprise.",
      },
      messageContent: {
        title: 'Contenu des Messages',
        content:
          "Lorsque vous utilisez notre plateforme pour envoyer des messages WhatsApp, nous stockons les modèles de messages, les informations sur les destinataires et le statut de livraison. Le contenu des messages est utilisé uniquement pour faciliter la livraison des messages et fournir des analyses. Nous ne partageons pas le contenu des messages avec des tiers, sauf si nécessaire pour livrer les messages via l'API WhatsApp Business.",
      },
      thirdPartyServices: {
        title: 'Services Tiers',
        content:
          "Nous utilisons les services tiers suivants pour faire fonctionner notre plateforme : Auth0 pour l'authentification, Bictorys pour le traitement des paiements et l'API Meta/WhatsApp Business pour la livraison des messages. Chacun de ces services a ses propres politiques de confidentialité qui régissent le traitement de vos données.",
      },
      thirdParty: {
        title: "Collecte d'Informations par des Tiers",
        content:
          'Nos fournisseurs de services tiers peuvent collecter des informations pour fournir leurs services. Bien que nous demandions à ces tiers de protéger vos informations, nous ne contrôlons pas leurs pratiques.',
      },
      howWeUse: {
        title: 'Comment Nous Utilisons les Informations Personnelles',
        content:
          'Nous utilisons les Informations Personnellement Identifiables pour : personnaliser la plateforme et offrir des services pertinents, répondre aux demandes de service, contacter les utilisateurs concernant des informations liées à la plateforme et répondre aux demandes.',
      },
      sharing: {
        title: "Partage d'Informations",
        content:
          "Nous ne vendons pas vos informations personnelles. Nous pouvons partager des données démographiques agrégées et non spécifiques avec des fournisseurs tiers à des fins d'analyse.",
      },
      hosting: {
        title: 'Hébergement et Localisation des Données',
        content:
          'Nos services sont hébergés sur une infrastructure cloud sécurisée. Les données peuvent être traitées et stockées dans des centres de données situés hors du Sénégal conformément à la réglementation applicable. Nous veillons à mettre en place des garanties appropriées pour tout transfert international de données.',
      },
      storage: {
        title: 'Stockage des Données',
        content:
          "Les Informations Personnellement Identifiables collectées par notre plateforme sont stockées de manière sécurisée et ne sont accessibles qu'à nos employés selon le besoin d'en connaître.",
      },
      choices: {
        title: 'Vos Choix',
        content:
          'Vous pouvez vous désabonner des communications en suivant les instructions dans nos e-mails ou en nous contactant directement.',
      },
      cookies: {
        title: 'Utilisation des Cookies',
        content:
          'Nous pouvons utiliser des cookies pour recueillir des informations sur les préférences des utilisateurs et pour sécuriser la plateforme en déconnectant automatiquement les utilisateurs inactifs.',
      },
      security: {
        title: 'Mesures de Sécurité',
        content:
          "Nous mettons en œuvre des mesures de sécurité conformes aux standards de l'industrie pour protéger vos données. Toutes les données sont chiffrées au repos et en transit. L'accès à nos systèmes est contrôlé par des permissions basées sur les rôles, une authentification sécurisée et un journal d'audit complet qui enregistre qui a accédé à quelles données et quand.",
      },
      userRights: {
        title: 'Vos Droits',
        content:
          "Conformément à la loi sénégalaise n°2008-12 sur la protection des données à caractère personnel, vous avez le droit d'accéder, de rectifier et de supprimer vos informations personnelles. Pour exercer ces droits, veuillez nous contacter en utilisant les informations fournies ci-dessous.",
      },
      corrections: {
        title: 'Correction des Informations',
        content:
          'Les utilisateurs peuvent mettre à jour ou corriger leurs Informations Personnellement Identifiables en nous contactant ou via les paramètres de leur compte.',
      },
      deletion: {
        title: 'Suppression des Informations',
        content:
          "Vous ou l'administrateur de votre organisation pouvez demander la suppression permanente des données personnelles via notre système d'effacement des données. Les demandes d'effacement entrent dans un délai de grâce de 30 jours avant exécution, pendant lequel elles peuvent être annulées. Une fois exécuté, toutes les données personnelles sont définitivement supprimées de nos systèmes actifs. Les enregistrements de messages sont anonymisés (données personnelles remplacées par [REDACTED]) pour préserver les données d'analyse non identifiantes. Certaines données résiduelles peuvent rester dans les sauvegardes chiffrées pour une durée limitée.",
      },
      retention: {
        title: 'Conservation des Données',
        content:
          "Nous conservons vos données aussi longtemps que nécessaire pour fournir nos services. À la fin de votre contrat ou à la suppression de votre compte, vos données seront conservées dans un état de suppression réversible. L'effacement permanent des données peut être demandé par un administrateur de l'organisation via notre système de demandes d'effacement, sous réserve du délai de grâce de 30 jours. Notre plateforme respecte le droit à l'effacement du RGPD (Article 17) et la loi sénégalaise sur la protection des données personnelles (Loi n°2008-12).",
      },
      changes: {
        title: 'Modifications de la Politique de Confidentialité',
        content:
          'Nous informerons les utilisateurs des modifications de la Politique de Confidentialité en publiant des mises à jour sur la plateforme. Les changements importants affectant les informations précédemment collectées seront communiqués directement.',
      },
      contact: {
        title: 'Nous Contacter',
        content:
          'Si vous avez des questions concernant cette Politique de Confidentialité ou si vous souhaitez exercer vos droits concernant vos informations personnelles, veuillez nous contacter à contact@dabsi.io.',
      },
    },
  },
  terms: {
    title: "Conditions Générales d'Utilisation",
    intro:
      "Ces Conditions Générales d'Utilisation s'appliquent à la plateforme Dabsi. En utilisant notre plateforme, vous acceptez ces conditions.",
    sections: {
      agreement: {
        title: 'Accord',
        content:
          "En accédant ou en utilisant dabsi.io ou l'un de ses sous-domaines, vous confirmez que vous avez l'autorité d'agir en votre nom ou au nom de toute entité que vous représentez. Votre utilisation de la plateforme constitue votre reconnaissance que vous avez lu et accepté ces Conditions d'Utilisation et notre Politique de Confidentialité.",
      },
      parties: {
        title: "Parties à l'Accord",
        content:
          'Cet accord est conclu entre les utilisateurs — qui comprennent toutes les personnes qui accèdent, consultent, utilisent ou interagissent avec la plateforme — et Dabsi, le propriétaire et opérateur de la plateforme.',
      },
      serviceNature: {
        title: 'Nature du Service',
        content:
          "DABSI agit comme prestataire technologique facilitant l'accès à des plateformes tierces, notamment l'API WhatsApp Business de Meta. DABSI ne contrôle pas l'infrastructure de Meta, les politiques de WhatsApp ou la disponibilité des services tiers. Les interruptions de service ou les changements imposés par des tiers sont hors de notre contrôle.",
      },
      disclaimer: {
        title: 'Avertissement sur le Contenu de la Plateforme',
        content:
          "La plateforme décline toute responsabilité quant à l'exactitude du contenu affiché, lié ou mentionné sur ce site. Les utilisateurs assument tous les risques liés à l'utilisation de ces informations. Nous déclinons également toute responsabilité pour tout dommage aux appareils ou aux données des utilisateurs.",
      },
      metaDisclaimer: {
        title: 'Avertissement concernant Meta',
        content:
          "Cette plateforme n'est pas affiliée à, approuvée par ou associée à Meta ou Meta Platforms de quelque manière que ce soit. Les utilisateurs doivent se conformer aux conditions d'utilisation de Meta et WhatsApp lorsqu'ils utilisent notre plateforme pour envoyer des messages.",
      },
      serviceAvailability: {
        title: 'Disponibilité du Service',
        content:
          "DABSI fournit ses services avec des efforts raisonnables mais ne peut garantir une disponibilité continue et ininterrompue. La plateforme peut connaître des temps d'arrêt pour maintenance, mises à jour ou circonstances hors de notre contrôle. Des accords de niveau de service (SLA) peuvent être disponibles pour les clients entreprise. Nous ne sommes pas responsables des pertes résultant d'interruptions de service.",
      },
      liability: {
        title: 'Limitation de Responsabilité',
        content:
          "En utilisant cette plateforme, vous acceptez de limiter les réclamations pour dommages. DABSI ne pourra être tenue responsable des pertes indirectes ou des interruptions causées par des services tiers. Dans les juridictions qui n'autorisent pas de telles exclusions, notre responsabilité maximale sera limitée au montant que vous avez payé pour utiliser nos services.",
      },
      indemnification: {
        title: 'Indemnisation',
        content:
          "Vous acceptez d'indemniser et de défendre la plateforme contre toute réclamation ou dommage résultant de vos actions qui causent un préjudice à la plateforme ou à des tiers.",
      },
      registration: {
        title: 'Inscription',
        content:
          "Vous devrez peut-être vous inscrire pour utiliser la plateforme. Vous êtes responsable de l'exactitude des informations fournies lors de l'inscription. Vous acceptez de garder votre mot de passe confidentiel et êtes responsable de toutes les activités sous votre compte.",
      },
      ip: {
        title: 'Droits de Propriété Intellectuelle',
        content:
          "Sauf indication contraire, la plateforme et tout son contenu sont la propriété de Dabsi ou de ses concédants de licence et sont protégés par les lois sur la propriété intellectuelle. Vous bénéficiez d'une licence limitée pour accéder et utiliser la plateforme aux fins prévues.",
      },
      management: {
        title: 'Gestion de la Plateforme',
        content:
          "Nous nous réservons le droit de surveiller la plateforme pour assurer la conformité avec ces Conditions, d'engager des actions en justice contre les violations et de gérer la plateforme pour protéger nos droits et assurer son bon fonctionnement.",
      },
      termination: {
        title: 'Suspension et Résiliation de Compte',
        content:
          'Ces Conditions restent en vigueur tant que vous utilisez la plateforme. DABSI peut suspendre ou résilier tout compte en cas de non-respect de ces Conditions, de violation des lois applicables ou pour toute autre raison à notre discrétion.',
      },
      subscriptions: {
        title: 'Tarification et Paiements',
        content:
          "Les services sont facturés selon le modèle tarifaire applicable à votre forfait, y compris les options de paiement à l'utilisation. En utilisant les services payants, vous acceptez de payer les frais applicables. Les tarifs peuvent évoluer en fonction des changements imposés par des fournisseurs tiers comme Meta.",
      },
      priceModification: {
        title: 'Modification des Prix',
        content:
          "DABSI se réserve le droit d'ajuster ses prix avec un préavis raisonnable. Les changements de prix peuvent résulter de modifications des coûts des tiers, des conditions du marché ou d'améliorations de service. L'utilisation continue de la plateforme après les changements de prix constitue une acceptation de la nouvelle tarification.",
      },
      refunds: {
        title: 'Politique de Remboursement',
        content:
          "Les frais ne sont généralement pas remboursables. Si vous annulez votre abonnement, vous conserverez l'accès aux fonctionnalités payantes jusqu'à la fin de votre période de facturation en cours. Aucun remboursement partiel n'est fourni pour les portions inutilisées d'une période de facturation. Dans des circonstances exceptionnelles, les demandes de remboursement peuvent être examinées à notre discrétion.",
      },
      acceptableUse: {
        title: 'Utilisation Acceptable',
        content:
          "Les services doivent être utilisés uniquement à des fins professionnelles conformes aux politiques de Meta. Vous acceptez de ne pas utiliser la plateforme pour : le spam ou les messages non sollicités, la fraude ou les pratiques trompeuses, le contenu illégal ou nuisible, le harcèlement ou l'abus, la désinformation, ou toute activité violant les conditions d'utilisation de WhatsApp. Vous êtes responsable du contenu de vos messages.",
      },
      whatsapp: {
        title: 'Utilisation de WhatsApp',
        content:
          "Notre plateforme facilite l'envoi de messages WhatsApp via l'API officielle WhatsApp Business. Vous êtes responsable de vous assurer que vos messages sont conformes aux politiques de WhatsApp, y compris l'obtention du consentement approprié des destinataires et l'interdiction d'envoyer du spam ou du contenu interdit.",
      },
      applicableLaw: {
        title: 'Droit Applicable',
        content:
          "Les présentes Conditions d'Utilisation sont régies par le droit sénégalais. Tout litige découlant de l'utilisation de cette plateforme sera soumis à la juridiction des tribunaux sénégalais.",
      },
      contact: {
        title: 'Nous Contacter',
        content:
          "Si vous avez des questions concernant ces Conditions d'Utilisation, veuillez nous contacter à contact@dabsi.io.",
      },
    },
  },
  whatchat: {
    modules: {
      inbox: 'Boîte de réception',
      inboxDesc: 'Voir et répondre aux conversations',
      metrics: 'Métriques',
      metricsDesc: "Performance de l'équipe et temps de réponse",
    },
    metrics: {
      title: "Métriques d'équipe",
      today: "Aujourd'hui",
      last7days: '7 derniers jours',
      last30days: '30 derniers jours',
      custom: 'Personnalisé',
      pickDateRange: 'Choisir une plage de dates',
      totalConversations: 'Total des conversations',
      agent: 'Agent',
      messagesSent: 'Messages envoyés',
      conversationsHandled: 'Conversations gérées',
      avgFirstResponse: 'Temps de réponse moyen',
      avgResolution: 'Temps de résolution moyen',
      noData: 'Aucune donnée pour cette période',
      trendTitle: 'Volume de conversations',
      inbound: 'Entrants',
      outbound: 'Sortants',
      viewAgentConversations: 'Voir les conversations de',
    },
    inbox: {
      title: 'Boîte de réception',
      selectPhoneNumber: 'Sélectionner un numéro',
      noConversations: 'Aucune conversation pour le moment',
      searchContacts: 'Rechercher des contacts...',
      selectConversation: 'Sélectionnez une conversation pour commencer',
      sessionActive: 'Session Active',
      sessionActiveTooltip:
        'Le client a envoyé un message dans les dernières 24h — messagerie libre disponible',
      sessionExpired: 'Session Expirée',
      sessionExpiredTooltip:
        'Seuls les messages modèles peuvent être envoyés en dehors de la fenêtre de 24h',
      messagePlaceholder: 'Tapez un message...',
      captionPlaceholder: 'Ajouter une légende...',
      attachFile: 'Joindre un fichier',
      send: 'Envoyer',
      templateOnly: 'Session expirée — modèles uniquement',
      templateOnlyTitle: 'Session expirée',
      templateOnlyDescription:
        'Envoyez un modèle pour rouvrir la conversation. Les messages libres seront à nouveau disponibles après la réponse du client.',
      chooseTemplate: 'Choisir un modèle',
      templateComposerTitle: 'Choisir un modèle',
      templateComposerDescription:
        "Sélectionnez un modèle, vérifiez-le, puis envoyez-le d'ici.",
      templateSendError: "Échec de l'envoi du modèle",
      templateUnsupportedLocation:
        'Les modèles avec en-tête de localisation ne sont pas encore pris en charge ici.',
      templateUnsupportedButtons:
        'Les modèles avec boutons coupon dynamiques ne sont pas encore pris en charge ici.',
      templateUnsupportedMedia:
        'Les modèles avec en-tête image ou vidéo ne sont pas encore pris en charge ici.',
      templatePreparingMedia: 'Préparation du média du modèle...',
      templateMissingMedia:
        "Ce modèle a besoin d'un média d'exemple avant de pouvoir être envoyé ici.",
      templateUnavailable: "Ce modèle n'est pas disponible",
      you: 'Vous :',
      agent: 'Agent',
      noMessages: 'Aucun message dans cette conversation',
      loadError: 'Échec du chargement des conversations',
      sendError: "Échec de l'envoi du message",
      sendFailed: 'Non envoyé',
      retry: 'Réessayer',
      dismiss: 'Ignorer',
      agentMode: 'Mode agent',
      agentModeTooltip: 'Le bot est en pause — vous gérez cette conversation',
      releaseToBot: 'Rendre au bot',
      mediaUnavailable: 'Média indisponible',
      mediaImage: 'Image',
      mediaDocument: 'Document',
      mediaLocation: 'Localisation',
      mediaContact: 'Contact',
      back: 'Retour',
      refresh: 'Actualiser',
      pending: 'En attente',
      pendingQueued: "En attente : en file d'attente",
      pendingProcessing: 'En attente : en cours de traitement',
      pendingOutbound:
        'En attente : transmis, en attente des mises a jour de livraison',
      cannedResponses: 'Réponses rapides',
      cannedResponsesDesc:
        'Extraits de messages enregistrés que vous pouvez insérer avec /',
      addCannedResponse: 'Ajouter une réponse rapide',
      editCannedResponse: 'Modifier la réponse rapide',
      deleteCannedResponse: 'Supprimer la réponse rapide',
      shortcut: 'Raccourci',
      title2: 'Titre',
      content: 'Contenu',
      noCannedResponses: 'Aucune réponse rapide',
      noCannedResponseMatches:
        'Aucune réponse rapide ne correspond à votre recherche',
      cannedResponseSaved: 'Réponse rapide enregistrée',
      cannedResponseDeleted: 'Réponse rapide supprimée',
      confirmDeleteCannedResponse:
        'Êtes-vous sûr de vouloir supprimer cette réponse rapide ?',
      statusOpen: 'Ouvert',
      statusPending: 'En attente',
      statusResolved: 'Résolu',
      statusArchived: 'Archivé',
      statusAll: 'Tous',
      changeStatus: 'Changer le statut',
      assignedTo: 'Assign\u00e9 \u00e0',
      unassigned: 'Non assign\u00e9',
      assignAgent: 'Assigner un agent',
      myConversations: 'Les miennes',
      allConversations: 'Tous',
      unassignedConversations: 'Non assign\u00e9es',
      contactInfo: 'Infos contact',
      tags: 'Tags',
      about: 'À propos',
      addAbout: 'Ajouter une description',
      groups: 'Groupes',
      stats: 'Statistiques',
      totalMessages: 'Total des messages',
      firstMessage: 'Premier message',
      lastMessage: 'Dernier message',
      noContactInfo: 'Aucune info de contact disponible',
      notesSaved: 'Notes enregistrées',
      tagsSaved: 'Tags enregistrés',
      addTags: 'Ajouter des tags...',
      notesPlaceholder: 'Ajouter des notes sur ce contact...',
      conversationNotes: 'Notes',
      addNote: 'Ajouter une note...',
      noteSaved: 'Note enregistr\u00e9e',
      noNotes: 'Aucune note',
      deleteNote: 'Supprimer la note',
      deleteNoteConfirm:
        '\u00cates-vous s\u00fbr de vouloir supprimer cette note\u00a0? Cette action est irr\u00e9versible.',
      filteredByAgent: 'Filtr\u00e9\u00a0: {email}',
      filteredByDate: 'Date\u00a0: {from} \u2013 {to}',
      clearFilter: 'Effacer le filtre',
      viewing: 'consulte',
      filterStatus: 'Statut',
      filterAssignment: 'Attribution',
      filterUnreadOnly: 'Non lus uniquement',
      filterDateRange: 'Période',
      filterTags: 'Tags',
      filterTagsPlaceholder: 'Tous les tags',
      noTagsFound: 'Aucun tag correspondant',
      moreFilters: 'Plus de filtres',
      selected: 'sélectionnés',
      selectAll: 'Tout sélectionner',
      conversations: 'conversations',
      conversation: 'conversation',
      resolve: 'Résoudre',
      archive: 'Archiver',
      clearSelection: 'Effacer',
      bulkActionSuccess: 'Mis à jour avec succès',
      assignTo: 'Assigner à...',
      newMessage: 'Nouveau message',
      notificationPermission:
        'Activez les notifications pour être alerté des nouveaux messages',
      enableNotifications: 'Activer les notifications',
    },
  },
  pricing: {
    title: 'Tarification simple, par application',
    subtitle:
      'Choisissez les applications dont vous avez besoin. Chacune a son propre forfait. Plus d\u2019apps, plus de remise.',
    seeFullDetails: 'Voir tous les d\u00e9tails tarifaires',
    perMonth: '/mois',
    startingAt: 'D\u00e8s',
    contactUs: 'Contactez-nous',
    getStarted: 'Commencer',
    custom: 'Sur mesure',
    customDescription: 'Besoin de plus ? Parlons-en.',

    starter: 'Starter',
    pro: 'Pro',

    coreApps: 'Applications',
    addOns: 'Options',
    bundleDiscounts: 'Remises multi-apps',

    apps: {
      clientell: 'Clientell',
      whatchat: 'WhatChat',
      rakine: 'Rakine',
      imminote: 'Imminote',
    },
    appTaglines: {
      clientell: 'Envois group\u00e9s WhatsApp',
      whatchat: 'Bo\u00eete de r\u00e9ception partag\u00e9e',
      rakine: 'Gestion des livraisons',
      imminote: 'Notifications automatis\u00e9es via API',
    },

    appFeatures: {
      clientellStarter: [
        'Jusqu\u2019\u00e0 5 000 contacts',
        '20 000 messages/mois',
        '1 num\u00e9ro de t\u00e9l\u00e9phone',
        'Analyses',
      ],
      clientellPro: [
        'Jusqu\u2019\u00e0 25 000 contacts',
        '100 000 messages/mois',
        '5 num\u00e9ros de t\u00e9l\u00e9phone',
        'Planification de messages',
        'Acc\u00e8s API complet',
        'Analyses',
      ],
      whatchatStarter: [
        '2 postes d\u2019agents',
        'Bo\u00eete de r\u00e9ception partag\u00e9e',
        'Mises \u00e0 jour en temps r\u00e9el',
      ],
      whatchatPro: [
        '10 postes d\u2019agents',
        'Bo\u00eete de r\u00e9ception partag\u00e9e',
        'Mises \u00e0 jour en temps r\u00e9el',
        'R\u00e9sum\u00e9s de conversations IA',
      ],
      rakineStarter: [
        'Jusqu\u2019\u00e0 100 livreurs',
        'Suivi en temps r\u00e9el',
        'Dispatch de livraisons',
      ],
      rakinePro: [
        'Jusqu\u2019\u00e0 500 livreurs',
        'Suivi en temps r\u00e9el',
        'Dispatch de livraisons',
        'Recherche et analyses IA',
      ],
      imminoteStarter: ['2 000 messages API/mois', 'API REST + SDKs'],
      imminotePro: ['10 000 messages API/mois', 'API REST + SDKs', 'Webhooks'],
    },

    addOnLabels: {
      botmaker: 'Botmaker',
      extra_seats: 'Postes suppl\u00e9mentaires',
      extra_numbers: 'Num\u00e9ros suppl\u00e9mentaires',
      priority_support: 'Support prioritaire',
      data_export: 'Export de donn\u00e9es',
    },
    addOnDescriptions: {
      botmaker:
        'Cr\u00e9ateur de chatbot sans code \u2014 fonctionne avec Clientell, WhatChat & Rakine',
      extra_seats: 'Postes suppl\u00e9mentaires pour toutes vos applications',
      extra_numbers: 'Num\u00e9ros WhatsApp suppl\u00e9mentaires',
      priority_support:
        'Support prioritaire par email et chat pour toutes vos apps',
      data_export: 'Exportez vos donn\u00e9es depuis toutes vos applications',
    },

    bundleNote:
      'Abonnez-vous \u00e0 plusieurs applications et \u00e9conomisez automatiquement.',
    bundleTiers: [
      '2 apps \u2014 10% de remise',
      '3 apps \u2014 15% de remise',
      '4 apps \u2014 20% de remise',
    ],

    // Checkout page
    checkoutTitle: 'Composez votre forfait',
    checkoutSubtitle:
      'S\u00e9lectionnez les applications et options dont votre \u00e9quipe a besoin.',
    checkoutChooseApps: 'Choisissez vos applications',
    checkoutSelectTier: 'Choisissez un forfait',
    checkoutAddOns: 'Options (facultatif)',
    checkoutSummary: 'R\u00e9capitulatif',
    checkoutSubtotal: 'Sous-total',
    checkoutBundleDiscount: 'Remise multi-apps',
    checkoutTotal: 'Total',
    checkoutSubscribe: 'S\u2019abonner',
    checkoutConfirmChanges: 'Confirmer les modifications',
    checkoutYouSave:
      'Vous \u00e9conomisez {percent}% gr\u00e2ce \u00e0 la remise multi-apps\u00a0!',
    checkoutEmpty: 'S\u00e9lectionnez au moins une application pour commencer.',
    checkoutSuccessTitle: 'Abonnement soumis',
    checkoutSuccessMessage:
      'Votre abonnement a \u00e9t\u00e9 soumis avec succ\u00e8s. Nous reviendrons vers vous rapidement.',
    checkoutErrorMessage: 'Une erreur est survenue. Veuillez r\u00e9essayer.',
    checkoutPaymentPendingTitle:
      'Abonnement enregistr\u00e9, paiement en attente',
    checkoutPaymentPendingMessage:
      "Votre p\u00e9riode d'essai a \u00e9t\u00e9 activ\u00e9e mais nous n'avons pas pu ouvrir la page de paiement. R\u00e9essayez depuis votre profil ou contactez le support si le probl\u00e8me persiste.",
    checkoutConfirmTitle: 'Confirmer l\u2019abonnement',
    checkoutConfirmTitleUpdate: 'Mettre \u00e0 jour l\u2019abonnement',
    checkoutConfirmMessage:
      'Vous \u00eates sur le point de souscrire au plan suivant. Vous pouvez modifier ou annuler \u00e0 tout moment.',
    checkoutConfirmMessageUpdate:
      'Votre abonnement sera mis \u00e0 jour avec le plan suivant. Les changements prennent effet imm\u00e9diatement.',
    checkoutConfirmBack: 'Retour',
    checkoutConfirmProceed: 'Confirmer et souscrire',
    checkoutConfirmProceedUpdate: 'Confirmer et mettre \u00e0 jour',
    checkoutAdminRequiredTitle: 'Acc\u00e8s admin requis',
    checkoutAdminRequiredMessage:
      'Seul un admin peut g\u00e9rer les abonnements. Contactez l\u2019admin de votre organisation.',
    noActiveAppsTitle: 'Aucune application active',
    noActiveAppsMessage:
      'Votre organisation n\u2019a pas d\u2019abonnement actif. Souscrivez pour commencer.',
    browsePlans: 'Voir les forfaits',
    checkoutMobileSummary: 'Voir le r\u00e9sum\u00e9',
    pricingLoadError:
      'Impossible de charger les tarifs. V\u00e9rifiez votre connexion et r\u00e9essayez.',
    retry: 'R\u00e9essayer',
    nextRenewalOn: 'Prochain renouvellement le {date}',
    dueToday: '\u00c0 payer aujourd\u2019hui',
    cancelling: 'Annulation',
    cancelsAtRenewal: 'Se termine au prochain renouvellement',
    undoCancel: 'R\u00e9tablir',
    undoCancelError:
      'Impossible d\u2019annuler l\u2019annulation. Si l\u2019abonnement est d\u00e9j\u00e0 termin\u00e9, r\u00e9abonnez-vous via le checkout.',
    alreadyPaidThisCycle: 'D\u00e9j\u00e0 pay\u00e9 ce cycle',
    nothingToCommitHint:
      'Votre abonnement est \u00e0 jour — rien \u00e0 enregistrer.',
    checkoutNoChargeTitle: 'Rien \u00e0 payer',
    checkoutNoChargeMessage:
      'Votre abonnement est \u00e0 jour. Aucun paiement n\u2019est requis pour le moment.',

    // Subscription management (profile page)
    yourApps: 'Vos applications',
    noActiveSubscriptions: 'Aucun abonnement actif. Souscrivez pour commencer.',
    managePlan: 'G\u00e9rer le forfait',
    trialEnds: "Fin de l'essai",
    nextBilling: 'Prochaine facturation',
    cancelApp: 'Annuler',
    cancelAppConfirm:
      '\u00cates-vous s\u00fbr de vouloir annuler {app}\u00a0? L\u2019acc\u00e8s continue jusqu\u2019\u00e0 la fin de votre p\u00e9riode de facturation.',
    cancelAppSuccess:
      "L'abonnement {app} sera annul\u00e9 \u00e0 la fin de la p\u00e9riode de facturation.",
    cancelAppError:
      "Impossible d'annuler l'abonnement. Veuillez r\u00e9essayer.",
    paymentRequired: 'Paiement requis',
    paymentPausedMessage: "L'acc\u00e8s est suspendu jusqu'au paiement.",
    payNow: 'Payer maintenant',
    payNowError:
      'Impossible de d\u00e9marrer le paiement. Veuillez r\u00e9essayer.',
    monthlyTotal: 'Total mensuel',
    nextRenewalTotal: 'Prochain renouvellement',
    activeAddOns: 'Options actives',
    bundleDiscount: 'Remise multi-apps',
    quantity: 'Qt\u00e9',

    // Mobile bar
    mobileBarOneApp: '1 appli',
    mobileBarMultipleApps: '{count} applis',

    // FAQ (new, app-based)
    faqTitle: 'FAQ',
    faqs: [
      {
        question: 'Comment fonctionne l\u2019essai gratuit ?',
        answer:
          'Chaque application inclut un essai gratuit de 14 jours sur le forfait Starter, sans carte bancaire. L\u2019essai est unique par application \u2014 si vous annulez Clientell puis vous y r\u00e9abonnez plus tard, vous passerez directement \u00e0 un abonnement payant.',
      },
      {
        question: 'Puis-je m\u2019abonner \u00e0 une seule application ?',
        answer:
          'Bien s\u00fbr. Choisissez uniquement les apps dont vous avez besoin. Vous pouvez en ajouter \u00e0 tout moment.',
      },
      {
        question: 'Comment fonctionne la facturation ?',
        answer:
          'Toute votre organisation partage un seul cycle de facturation. Lors de votre premier paiement, nous fixons votre prochain renouvellement \u00e0 30 jours. Chaque app que vous ajoutez ensuite se renouvelle \u00e0 la m\u00eame date \u2014 une seule facture, un seul cycle, pas de dates \u00e9parpill\u00e9es \u00e0 suivre.',
      },
      {
        question:
          'Que se passe-t-il si j\u2019ajoute une app ou passe \u00e0 un forfait sup\u00e9rieur en cours de cycle ?',
        answer:
          'Vous ne payez que les jours restants jusqu\u2019\u00e0 votre prochain renouvellement, au prorata du nouveau tarif. Votre date de renouvellement reste la m\u00eame, et le mois suivant tout se renouvelle ensemble. Passer d\u2019un forfait Starter \u00e0 Pro vous est factur\u00e9 en prorata de la diff\u00e9rence pour les jours restants.',
      },
      {
        question:
          'Puis-je annuler une app ou l\u2019ensemble de mon abonnement ?',
        answer:
          'Oui, \u00e0 tout moment. Vous conservez l\u2019acc\u00e8s jusqu\u2019\u00e0 la fin de votre cycle en cours \u2014 il n\u2019y a pas de remboursement au prorata \u2014 et l\u2019app annul\u00e9e ne se renouvelle simplement pas. Vous pouvez vous r\u00e9abonner plus tard quand vous le souhaitez.',
      },
      {
        question: 'Comment fonctionnent les remises multi-apps ?',
        answer:
          'Les remises sont appliqu\u00e9es automatiquement d\u00e8s que vous vous abonnez \u00e0 2 applications ou plus. Plus vous utilisez d\u2019apps, plus la remise est importante.',
      },
      {
        question: 'Quels modes de paiement acceptez-vous ?',
        answer:
          'Nous acceptons les paiements par carte, Orange Money et Wave Money. Les clients sur mesure peuvent discuter d\u2019options suppl\u00e9mentaires.',
      },
      {
        question: 'Qu\u2019est-ce que le forfait Sur mesure ?',
        answer:
          'Le forfait Sur mesure est destin\u00e9 aux entreprises ayant besoin de limites plus \u00e9lev\u00e9es, d\u2019un support d\u00e9di\u00e9 ou d\u2019int\u00e9grations personnalis\u00e9es. Contactez notre \u00e9quipe et nous cr\u00e9erons un plan adapt\u00e9.',
      },
      {
        question: 'Comment fonctionne Botmaker en tant qu\u2019option ?',
        answer:
          'Botmaker est un cr\u00e9ateur de chatbot sans code qui peut \u00eatre ajout\u00e9 \u00e0 n\u2019importe quelle application. Un seul abonnement couvre toutes vos apps connect\u00e9es.',
      },
      {
        question: 'Offrez-vous des r\u00e9ductions pour les associations ?',
        answer:
          'Oui. Contactez notre \u00e9quipe commerciale pour des tarifs sp\u00e9ciaux pour les organisations \u00e0 but non lucratif.',
      },
    ],
  },
  admin: {
    pageTitle: 'Administration des tarifs',
    pageSubtitle:
      'G\u00e9rer les plans, options et abonnements des organisations.',
    plansTab: 'Plans',
    addOnsTab: 'Options',
    orgsTab: 'Organisations',
    app: 'Application',
    starterPrice: 'Starter',
    proPrice: 'Pro',
    features: 'Cl\u00e9 fonctionnalit\u00e9s',
    bundleDiscountsTitle: 'Remises groupes',
    apps: 'apps',
    discount: 'de remise',
    addOnName: 'Option',
    price: 'Prix',
    stackable: 'Cumulable',
    unit: 'Unit\u00e9',
    quoteBased: 'Sur devis',
    yes: 'Oui',
    no: 'Non',
    orgName: 'Organisation',
    subscribedApps: 'Apps souscrites',
    activeAddOns: 'Options',
    status: 'Statut',
    manage: 'G\u00e9rer',
    none: 'Aucun',
    noOrgs: 'Aucune organisation trouv\u00e9e.',
    manageOrg: 'G\u00e9rer l\u2019abonnement',
    appSubscriptions: 'Abonnements apps',
    addOnsTitle: 'Options',
    off: 'D\u00e9sactiv\u00e9',
    on: 'Activ\u00e9',
    subtotal: 'Sous-total',
    bundleDiscount: 'Remise groupe',
    monthlyTotal: 'Total mensuel',
    cancel: 'Annuler',
    saveChanges: 'Enregistrer',
    adminPricing: 'Admin : Tarifs',
    editPrices: 'Modifier les prix',
    editPricesFor: 'Modifier les prix de',
    confirmPriceChange:
      '\u00cates-vous s\u00fbr de vouloir mettre \u00e0 jour ces prix ?',
    priceUpdateSuccess: 'Prix mis \u00e0 jour avec succ\u00e8s.',
    priceUpdateError: '\u00c9chec de la mise \u00e0 jour des prix.',
    currentPrice: 'Actuel',
    newPrice: 'Nouveau',
    noChanges: 'Aucun changement \u00e0 enregistrer.',
    perMonth: '/mois',
    editFeatures: 'Modifier les fonctionnalit\u00e9s',
    editFeaturesFor: 'Modifier les fonctionnalit\u00e9s de',
    featureKey: 'Cl\u00e9',
    featureValue: 'Valeur',
    addFeature: 'Ajouter une fonctionnalit\u00e9',
    selectFeatureKey: 'Choisir une fonctionnalit\u00e9',
    removeFeature: 'Supprimer',
    featureUpdateSuccess:
      'Fonctionnalit\u00e9s mises \u00e0 jour avec succ\u00e8s.',
    featureUpdateError:
      '\u00c9chec de la mise \u00e0 jour des fonctionnalit\u00e9s.',
    confirmFeatureChange:
      '\u00cates-vous s\u00fbr de vouloir mettre \u00e0 jour ces fonctionnalit\u00e9s ?',
    noFeatureChanges:
      'Aucune modification de fonctionnalit\u00e9 \u00e0 enregistrer.',
    currentValue: 'Actuel',
    newValue: 'Nouveau',
    removed: 'Supprim\u00e9',
    added: 'Ajout\u00e9',
  },
};
